<template>
    <div>

        <div class="progress mt-1 mb-1" v-if="false">
            <div class="indeterminate" v-if="$store.state.loading"></div>
            <div class="determinate" v-else></div>
        </div>

        <div id="print-orcamento">

            <pre v-if="false">{{ dados }}</pre>

            <cabecalho-generico 
                :titulo="'Orçamento ' + ( id_orcamento ? '#' + id_orcamento : '' )" 
                :show_cnpj="!dados || !dados.unidade_operacao" 
                :cabecalho="cabecalho"
                :show_logo="true"
                :nome_empresa="( cabecalho && cabecalho.st_nome_empresa ) ? cabecalho.st_nome_empresa : null"
                hide_campos2="tem_cabecalho_com_nome && cabecalho && cabecalho.logo"
                :logo="( cabecalho && cabecalho.logo && cabecalho.logo.arquivo && cabecalho.logo.arquivo.temporary_url ) 
                    ? cabecalho.logo.arquivo.temporary_url
                    : null">
                
                <div v-if="dados && dados.unidade_operacao && !( cabecalho && cabecalho.st_nome_empresa == '.' )">
                    {{ dados.unidade_operacao.search }}
                    <div>CNPJ: {{ dados.unidade_operacao.st_cnpj }}</div>
                </div>
                <div v-if="dados && dados.plano">
                    {{ dados.plano.search }}
                </div>
                <div v-if="orcamento && orcamento.created_at">
                    {{ $util.getFormatDate(orcamento.created_at) }}
                </div>
                <div v-else>
                    {{ $util.getFormatDate($util.hoje()) }}
                </div>
                <div v-if="nome_paciente">
                    Para: {{ nome_paciente }}
                </div>
                <div v-if="prazo_final">
                    Prazo: {{ $util.getFormatDate(prazo_final) }}
                </div>
                <div class="small mt-2">
                    Registrado por: {{ $store.state.user.st_login }}
                </div>
                <div v-if="titulo && titulo != nome_paciente" class="mt-3 lead">
                    {{ titulo }}
                </div>
            </cabecalho-generico>

            <div class="d-print-none row" v-if="!procedimentos || ( !procedimentos.length && !id_orcamento )">
                <div class="col col-12">
                    <az-empty-state 
                        icon="fas fa-file-invoice-dollar" 
                        msg="Orçamento"
                        action="Buscar Orçamento" 
                        :method="buscar_orcamento"/>
                </div>
            </div>

            <template v-else>

                <ul v-if="exibir_apenas_total" class="list-group mb-3">
                    <li class="list-group-item d-flex justify-content-between">
                        <div v-if="dados && dados.plano">
                            {{ dados.plano.search }}
                        </div>
                        <div>
                            {{ $util.formatMoeda(total_orcado) }}
                        </div>
                    </li>
                    <template v-if="desconto > 0">
                        <li class="list-group-item d-flex justify-content-between">
                            <div>
                                Desconto
                                <span v-if="tipo_desconto == 'P'">
                                    de {{ $util.formatMoeda(desconto) }}%
                                </span>
                            </div>
                            <div>
                                {{ $util.formatMoeda(valor_desconto) }}
                            </div>
                        </li>
                        <li class="list-group-item d-flex justify-content-between">
                            <div>
                                Valor Final
                            </div>
                            <div>
                                {{ $util.formatMoeda(total_orcado - valor_desconto) }}
                            </div>
                        </li>
                    </template>
                </ul>

                <table class="table bg-white" :class="imprimindo ? 'table-sm' : ''" v-else>
                    <thead>
                        <tr>
                            <th>Procedimento</th>
                            <th v-if="imprimindo">{{ tem_prazo ? 'Prazo' : '' }}</th>
                            <th>Código</th>
                            <th class="text-right">Qtde</th>
                            <th></th>
                            <th class="text-right">Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(item, idx) in procedimentos">
                            <tr :key="idx" v-if="true">
                                <td>
                                    <a href="#" @click.prevent="remover(idx)" class="text-danger d-print-none mr-2" v-if="pode_alterar_orcamento">
                                        <i class="fas fa-minus fa-fw"></i>
                                    </a>
                                    {{ item.procedimento.st_procedimento ? item.procedimento.st_procedimento : item.procedimento.search }}
                                    <span v-if="item.procedimento.id_classe_procedimento == 1" class="text-muted">
                                        {{ item.procedimento.especialidade.st_especialidade }}
                                    </span>
                                    <span v-if="item.procedimento.id_classe_procedimento == 1 && item.tipo_consulta" class="badge badge-warning badge-pill ml-2 mr-1" title="Tipo de Consulta">
                                        {{ item.tipo_consulta }}
                                    </span>

                                    <a href="#" @click.prevent="editar_consumo(idx)" class="card-link d-print-none" v-if="pode_alterar_orcamento">
                                        <i class="fas fa-cart-plus"></i>
                                    </a>
                                    <div v-if="item.medico" class="small text-muted ml-5">
                                        {{ item.medico.st_nome_exibicao }}
                                    </div>
                                    <div v-if="item.procedimento.in_prazo_entrega && !imprimindo" class="small text-muted ml-5">
                                        Prazo: 
                                        <span>{{ item.procedimento.in_prazo_entrega }}</span>
                                        <span class="ml-1">{{ traduzir_tempo(item.procedimento.in_prazo_entrega, item.procedimento.st_tempo_prazo_entrega) }}</span>
                                    </div>
                                </td>
                                <td v-if="imprimindo">
                                    <div v-if="item.procedimento.in_prazo_entrega" class="small text-muted">
                                        <span>{{ item.procedimento.in_prazo_entrega }}</span>
                                        <span class="ml-1">{{ traduzir_tempo(item.procedimento.in_prazo_entrega, item.procedimento.st_tempo_prazo_entrega) }}</span>
                                    </div>
                                </td>
                                <td>
                                    <!-- Help de Exames -->
                                    <a href="#" @click.prevent="abrir_help(item)" class="mr-2 d-print-none" title="Help de Exames" v-if="is_lab">
                                        <i class="fa-solid fa-circle-info"></i>
                                    </a>

                                    <!-- Código -->
                                    <span v-if="item.item_tabela">
                                        {{ item.item_tabela.st_codigo }}
                                    </span>
                                </td>
                                <td class="text-right" style="width: 150px;">
                                    <span v-if="imprimindo">
                                        {{ item.in_quantidade }}
                                    </span>
                                    <az-input
                                        v-else
                                        sizing="sm"
                                        :edicao="false" 
                                        type="number" 
                                        v-model="item.in_quantidade">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="pode_alterar_orcamento && !item.atendimento_pacote">
                                                <button class="btn btn-outline-danger" type="button" @click="alterar_qtde(item, false)"
                                                    v-if="item.in_quantidade > 1">
                                                    <i class="fa fa-minus-circle" aria-hidden="true"></i>
                                                </button>
                                                <button class="btn btn-outline-success" type="button" @click="alterar_qtde(item, true)">
                                                    <i class="fa fa-plus-circle" aria-hidden="true"></i>
                                                </button>
                                                <button type="button" class="btn btn-outline-primary" v-if="item.procedimento && item.procedimento.procedimento_pacotes && item.procedimento.procedimento_pacotes.length"
                                                    @click="ver_pacotes(item.procedimento.procedimento_pacotes, idx)">
                                                    <i class="fas fa-layer-group"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </td>
                                <td class="text-right" style="width: 150px;" v-if="!imprimindo && item.ed && !item.atendimento_pacote">
                                    <az-input
                                        v-if="pode_ver_valor"
                                        :key="'V' + idx"
                                        sizing="sm"
                                        :type="removendo ? 'number' : 'money'"
                                        v-model="item.dc_valor_procedimento" />
                                </td>
                                <td v-else></td>
                                <td class="text-right">
                                    <span :class="nao_exibir_valor_do_item ? 'd-print-none' : ''" v-if="pode_ver_valor && !item.atendimento_pacote">
                                        {{ $util.formatMoeda(item.dc_valor_procedimento * item.in_quantidade) }}
                                    </span>
                                </td>
                            </tr>
                            <tr :key="'PS' + idx" v-if="item.atendimento_pacote">
                                <td>
                                    <i class="fas fa-layer-group fa-fw mr-3 d-print-none"></i>
                                    <a href="#" @click.prevent="retirar_pacote(item)" class="text-danger d-print-none mr-2" v-if="pode_alterar_orcamento">
                                        <i class="fas fa-minus fa-fw"></i>
                                    </a>
                                    {{ item.atendimento_pacote.search }}
                                    
                                    <pre v-if="false">{{ item.atendimento_pacote }}</pre>
                                </td>
                                <td v-if="imprimindo"></td>
                                <td></td>
                                <td class="text-right">x{{ item.atendimento_pacote.in_quantidade_items }}</td>
                                <td class="text-right" style="width: 150px;" v-if="!imprimindo && item.ed">
                                    <az-input
                                        v-if="pode_ver_valor"
                                        sizing="sm"
                                        type="money"
                                        v-model="item.atendimento_pacote.dc_valor_pacote" />
                                </td>
                                <td class="text-right">{{ $util.formatMoeda(item.atendimento_pacote.dc_valor_pacote) }}</td>
                            </tr>
                            <tr :key="'PC' + idx" v-else-if="indexProcPacote == idx">
                                <td colspan="5">
                                    <div class="list-group">
                                        <button type="button" class="list-group-item list-group-item-action"
                                            v-for="(pacote, index) in pacotes" :key="index" @click="selecionar_pacote(pacote)">
                                            <i class="fas fa-layer-group mr-2 text-primary"></i>
                                            {{ pacote.search }}
                                        </button>
                                    </div>
                                </td>
                                <td v-if="imprimindo"></td>
                            </tr>
                            <template v-if="!nao_exibir_valor_do_item">
                                <template v-for="(comp, icx) in item.comparacao">
                                    <tr :key="'C' + idx + '.' + icx" v-if="true">
                                        <td colspan="3">
                                            <small class="text-muted ml-3">{{ comp.plano.search }}</small>
                                        </td>
                                        <td v-if="imprimindo"></td>
                                        <td class="text-right">
                                            <small v-if="pode_ver_valor" class="text-muted">{{ $util.formatMoeda(comp.valor.valor * item.in_quantidade) }}</small>
                                        </td>
                                    </tr>
                                </template>
                            </template>
                            <tr v-for="(consumo, icx) in item.atendimento_procedimento_consumos" :key="idx + '.' + icx" :class="exibir_mat_med_tx ? '' : 'd-print-none'">
                                <td colspan="2">
                                    <i class="fas fa-shopping-cart mr-3 d-print-none"></i>
                                    <a href="#" @click.prevent="remover_consumo(item, icx)" class="text-danger mr-2" v-if="pode_alterar_orcamento && !consumo.tch">
                                        <i class="fas fa-minus"></i>
                                    </a>
                                    {{ consumo.search }}
                                </td>
                                <td v-if="imprimindo"></td>
                                <td class="text-right" style="width: 150px;">
                                    <span v-if="imprimindo">
                                        {{ consumo.in_quantidade }}
                                    </span>
                                    <az-input
                                        v-else
                                        sizing="sm"
                                        :edicao="pode_alterar_orcamento" 
                                        type="number" 
                                        v-model="consumo.in_quantidade">
                                        <template v-slot:buttonposb v-if="false && pode_alterar_orcamento">
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-primary" type="button" @click="editar_qtde(consumo)">
                                                    <i class="fas fa-edit fa-fw"></i>
                                                </button>
                                                <button class="btn btn-outline-danger" type="button" @click="alterar_qtde_consumo(consumo, false)"
                                                    v-if="consumo.in_quantidade > 1">
                                                    <i class="fa fa-minus-circle fa-fw" aria-hidden="true"></i>
                                                </button>
                                                <button class="btn btn-outline-success" type="button" @click="alterar_qtde_consumo(consumo, true)">
                                                    <i class="fa fa-plus-circle fa-fw" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </td>

                                <!-- Edição do Valor -->
                                <td class="text-right" style="width: 150px;" v-if="!imprimindo && item.ed && !item.atendimento_pacote">
                                    <az-input
                                        v-if="pode_ver_valor"
                                        :key="'VC-' + idx"
                                        sizing="sm"
                                        :type="removendo ? 'number' : 'money'"
                                        v-model="consumo.dc_valor_unitario" />
                                </td>
                                <td v-else></td>
                                <!-- Fim Edição Valor -->

                                <td class="text-right">
                                    <span :class="nao_exibir_valor_do_item ? 'd-print-none' : ''" v-if="pode_ver_valor">
                                        {{ $util.formatMoeda(consumo.dc_valor_unitario * consumo.in_quantidade) }}
                                    </span>
                                </td>
                            </tr>
                            <tr :key="idx + 'mmt'" v-if="imprimindo && !exibir_mat_med_tx && item.atendimento_procedimento_consumos.length">
                                <td colspan="2">
                                    <i class="fas fa-shopping-cart mr-3"></i>
                                    <a href="#" class="text-danger mr-2">
                                        <i class="fas fa-minus"></i>
                                    </a>
                                    Materiais/Medicamentos/Taxas
                                </td>
                                <td class="text-right" style="width: 150px;">
                                    ...
                                </td>
                                <td v-if="imprimindo"></td>
                                <td></td>
                                <td class="text-right">
                                    {{ $util.formatMoeda(item.atendimento_procedimento_consumos.reduce((total, carry) => { 
                                        return total + ( carry.dc_valor_unitario * carry.in_quantidade );
                                    }, 0)) }}
                                </td>
                            </tr>
                            <tr :key="'NC'+ idx" v-if="linha_incluir_consumo === idx" class="d-print-none">
                                <td colspan="4">
                                    <az-input 
                                        class="ml-3 mb-3"
                                        sizing="sm"
                                        icon="fas fa-cart-plus fa-fw"
                                        buttonToolTip="Incluir material, medicamento ou taxa."
                                        type="autocomplete" 
                                        optionsMode="aql"
                                        optionsName="consumo.index" 
                                        service="consumo.index"
                                        :optionsParm="{ id_operadora: dados.plano.operadora.id_operadora }"
                                        :optionsSync="true"
                                        placeholder="Incluir material, medicamento ou taxa." 
                                        v-model="novoComponente"
                                        @input="incluirComponente (item)" />
                                </td>
                                <td v-if="imprimindo"></td>
                            </tr>
                        </template>
                    </tbody>
                    <tfoot v-if="procedimentos && procedimentos.length && pode_ver_valor">
                        <tr>
                            <th colspan="4">
                                Total
                                <span class="badge badge-secondary ml-2">
                                    {{ procedimentos.length }}
                                </span>
                            </th>
                            <th v-if="imprimindo"></th>
                            <th class="text-right">{{ $util.formatMoeda(total_orcado) }}</th>
                        </tr>
                        <template v-if="desconto > 0">
                            <tr>
                                <th colspan="2">
                                    Desconto
                                </th>
                                <th v-if="imprimindo"></th>
                                <th>
                                    <span v-if="tipo_desconto == 'P'">
                                        {{ $util.formatMoeda(desconto) }}%
                                    </span>
                                </th>
                                <th></th>
                                <th class="text-right">
                                    {{ $util.formatMoeda(valor_desconto) }}
                                </th>
                            </tr>
                            <tr>
                                <th colspan="4">
                                    Valor Final
                                </th>
                                <th v-if="imprimindo"></th>
                                <th class="text-right">{{ $util.formatMoeda(total_orcado - valor_desconto) }}</th>
                            </tr>
                        </template>
                    </tfoot>
                </table>

            </template>

            <div class="d-none d-print-block">
                <div v-if="parcelamento > 1" class="alert alert-info d-flex justify-content-between mt-3">
                    <div>
                        Parcelamento em {{ parcelamento }} vezes de...
                    </div>
                    <div> 
                        {{ $util.formatMoeda( (total_orcado - valor_desconto) / parcelamento ) }}
                    </div>
                </div>
            </div>

            <div class="d-none mt-3 alert alert-secondary" :class="observacoes ? 'd-print-block' : ''"
                style="white-space: pre-wrap;">{{ observacoes }}</div>

            <div class="d-none mt-3" :class="exibir_inst ? 'd-print-block' : ''">
                <az-instrucoes 
                    ref="instruc_orc"
                    :dados="dados" 
                    :procedimentos="value"
                    contexto="O"
                    :orcamento="true" />
            </div>

        </div>

        <div v-if="procedimentos && ( id_orcamento || procedimentos.length )">

            <div class="form-row">
                <div class="col col-12 col-md-9">
                    <az-input
                        label="Para (Nome do Paciente)"
                        required
                        :edicao="!id_orcamento"
                        :validate="validate"
                        v-model="nome_paciente">
                        <template v-slot:buttonposb>
                            <div class="input-group-append" v-if="id_orcamento">
                                <span class="input-group-text" id="basic-addon2">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" 
                                            id="orc_ativo" 
                                            v-model="orcamento.fl_ativo" 
                                            @change="toggle(orcamento)">
                                        <label class="custom-control-label" for="orc_ativo"></label>
                                    </div>
                                </span>
                                <span class="input-group-text" id="basic-addon2">
                                    #{{ id_orcamento }}
                                </span>
                                <az-audit-log-button model="orcamento" :id="id_orcamento" />
                                <button type="button" class="btn btn-outline-primary" v-if="orcamento && orcamento.arquivos && orcamento.id_orcamento == id_orcamento" @click="abrir_anexar_arquivo()">
                                    <i class="fa-solid fa-paperclip"></i>
                                    <span class="badge badge-primary ml-2" v-if="orcamento.arquivos.length">
                                        {{ orcamento.arquivos.length }}
                                    </span>
                                </button>
                                <button type="button" class="btn btn-outline-primary" v-if="paciente" @click="abrir_paciente()">
                                    <i class="fa fa-id-badge" aria-hidden="true"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
                <!-- Desconto Identificado -->
                <div class="col col-12 col-md-3" v-if="desconto_tipo_ident">
                    <az-input
                        type="autocomplete"
                        label="Desconto"
                        placeholder="Selecione o Desconto..."
                        service="desconto_tipos.index"
                        optionsMode="aql"
                        :optionsParm="{ 
                            id_plano: this.dados.plano.id_plano,
                            id_unidade_operacao: this.dados.unidade_operacao ? this.dados.unidade_operacao.id_unidade_operacao : null,
                            id_procedimentos: this.procedimentos.map(item => item.procedimento ? item.procedimento.id_procedimento : item.id_procedimento),  
                        }"
                        v-model="desconto_tipo" />
                </div>

                <div class="col col-12 col-md-3" v-else>
                    <az-input
                        type="money"
                        label="Desconto"
                        :edicao="pode_alterar_orcamento"
                        :validate="validate"
                        v-model="desconto">
                        <template v-slot:buttonposb>
                            <div class="input-group-append">
                                <div class="dropdown">
                                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                        :disabled="!pode_alterar_orcamento">
                                        <i class="fa fa-percent" aria-hidden="true" v-if="tipo_desconto == 'P'"></i>
                                        <i class="fas fa-dollar-sign" aria-hidden="true" v-if="tipo_desconto == 'V'"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="#" @click.prevent="tipo_desconto = 'P'">
                                            <i class="fa fa-percent fa fw mr-2" aria-hidden="true"></i>
                                            Percentual
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="tipo_desconto = 'V'">
                                            <i class="fas fa-dollar-sign fa-fw mr-2"></i>
                                            Valor
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </az-input>
                </div>
            </div>

            <div class="alert alert-primary d-flex justify-content-between mt-2 py-2" v-if="orcamento && orcamento.ocr_codigos && orcamento.ocr_codigos.length">
                <div class="text-nowrap text-truncate">Pedido: <strong>{{ orcamento.ocr_codigos.join(', ') }}</strong></div>
                <div>
                    <a href="#" @click.prevent="incluir_codigos(orcamento.ocr_codigos.join(', ') + ',')" class="text-nowrap">
                        <span class="badge badge-primary mr-2">{{ orcamento.ocr_codigos.length }}</span>
                        <i class="fa-solid fa-arrow-up"></i>
                    </a>
                </div>
            </div>

            <!-- Definição do Desconto -->
            <div class="form-row" v-if="desconto_tipo">
                <div class="col col-12 col-md-9">
                    <div class="small text-muted" v-if="orcamento && orcamento.usuario_desconto && orcamento.dt_desconto_autorizacao">
                        Desconto autorizador por {{ orcamento.usuario_desconto.st_login }} em {{ $util.getFormatDate(orcamento.dt_desconto_autorizacao) }} {{ orcamento.dt_desconto_autorizacao.slice(11,16) }}
                    </div>
                </div>
                <div class="col col-12 col-md-3">
                    <az-input
                        type="money"
                        label="Desconto"
                        :edicao="pode_alterar_orcamento"
                        :validate="validate"
                        v-model="desconto">
                        <template v-slot:button-pre>
                            <div class="input-group-prepend" v-if="orcamento && orcamento.id_usuario_desconto">
                                <span class="input-group-text" id="basic-addon2">
                                    <i class="fa fa-check-circle text-success" aria-hidden="true" title="Desconto validado."></i>
                                </span>
                            </div>
                            <div class="input-group-prepend" v-else-if="orcamento && orcamento.id_usuario_desconto === null">
                                <button type="button" class="btn btn-outline-warning" @click="aprovar_desconto()">
                                    <i class="fa-solid fa-circle-question" title="Desconto aguardando aprovação."></i>
                                </button>
                            </div>
                        </template>
                        <template v-slot:buttonposb>
                            <div class="input-group-append">
                                <div class="dropdown">
                                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                        :disabled="!pode_alterar_orcamento">
                                        <i class="fa fa-percent" aria-hidden="true" v-if="tipo_desconto == 'P'"></i>
                                        <i class="fas fa-dollar-sign" aria-hidden="true" v-if="tipo_desconto == 'V'"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="#" @click.prevent="tipo_desconto = 'P'">
                                            <i class="fa fa-percent fa fw mr-2" aria-hidden="true"></i>
                                            Percentual
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="tipo_desconto = 'V'">
                                            <i class="fas fa-dollar-sign fa-fw mr-2"></i>
                                            Valor
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </az-input>
                </div>
            </div>


            <div class="form-row">
                <div class="col col-12 col-md-9">
                    <az-input  
                        label="Título"
                        v-model="titulo" />
                </div>
                <div class="col col-12 col-md-3">
                    <az-input  
                        label="Parcelamento"
                        placeholder="Nenhum"
                        type="number"
                        :edicao="pode_alterar_orcamento"
                        v-model="parcelamento">
                        <template v-slot:buttonposb>
                            <div class="input-group-append" v-if="parcelamento > 1">
                                <span class="input-group-text" id="basic-addon2">parcelas</span>
                            </div>
                        </template>
                    </az-input>
                </div>
            </div>

            <div class="form-row" v-if="info">
                <div class="col col-12">
                    <medico-solicitante
                        ref="medico_solic"
                        v-model="info"
                        :validate="validate"
                        :block_executante="true"
                        :block_data="true"
                        :alter_proc="true"
                        :edicao="true" />
                </div>
            </div>

            <div class="form-row mb-3">
                <div class="col col-12">
                    <az-input  
                        label="Observações"
                        type="textarea"
                        :rows="observacoes ? 3 : 1"
                        v-model="observacoes" />
                </div>
            </div>

            <div class="form-row mb-3" v-if="js_classes">
                <div class="col col-12">
                    <multiselect
                        v-model="js_classes"
                        :options="options_classes"
                        :multiple="true"
                        :taggable="true"
                        @tag="addTag"
                        placeholder="Selecione uma classificação..."
                        selectLabel="Pressione [ENTER] para selecionar"
                        deselectLabel="Pressione [ENTER] para remover"
                        tagPlaceholder="Pressione [ENTER] para incluir"
                        selectedLabel="Selecionado">
                        <template slot="noOptions">
                            Nenhuma classificação selecionada.
                        </template>
                    </multiselect>
                </div>
            </div>

            <div class="alert d-flex justify-content-between" :class="( orcamento.dt_validade < $util.hoje() ? 'alert-danger' : 'alert-secondary' )" v-if="orcamento && orcamento.dt_validade && !orcamento_convertido">
                <div>
                    Validade: <strong>{{ $util.getFormatDate(orcamento.dt_validade) }}</strong>
                </div>
                <div>
                    {{ $util.getHumanDuration(orcamento.dt_validade) }}
                </div>
            </div>

            <div class="alert alert-success d-flex justify-content-between" v-if="orcamento && orcamento.pagamento && orcamento.pagamento.item_pagamento_atendimento_ativos && orcamento.pagamento.item_pagamento_atendimento_ativos.length">
                <div>
                    <strong>Orçamento Pago:</strong>
                    <ul class="mb-0">
                        <li v-for="(itp, itx) in orcamento.pagamento.item_pagamento_atendimento_ativos" :key="itx">
                            {{ itp.forma_pagamento.st_forma_pagamento }}
                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                            {{ $util.formatMoeda(itp.dc_valor) }}
                        </li>
                    </ul>
                </div>
                <div>
                    <a href="#" @click.prevent="pagar()">#{{ orcamento.pagamento.id_pagamento_atendimento }}</a>
                </div>
            </div>

            <ul class="list-group mb-3" v-if="orcamento && orcamento.id_orcamento == id_orcamento && orcamento.marcacoes && orcamento.marcacoes.length">
                <li class="list-group-item list-group-item-info" v-for="(marco, iox) in orcamento.marcacoes" :key="iox">
                    <div class="d-flex justify-content-between">
                        <div>
                            <div>
                                <i class="fa fa-calendar-plus-o fa-fw  mr-3" aria-hidden="true"></i>
                                Convertido para
                                <strong>{{ $util.getFormatDate(marco.dt_inicio) }}</strong>
                                <span class="ml-2">{{ marco.dt_inicio.substr(11,5) }}</span>
                            </div>
                            <div v-if="marco.medico">
                                <i class="fa fa-user-md fa-fw mr-3" aria-hidden="true"></i>
                                <span class="text-muted small">
                                    {{ marco.medico.st_nome_exibicao }}
                                </span>
                            </div>
                            <div v-if="marco.unidade_operacao">
                                <i class="fa fa-building fa-fw mr-3" aria-hidden="true"></i>
                                <span class="text-muted small">
                                    {{ marco.unidade_operacao.st_nome }}
                                </span>
                            </div>
                            <div v-if="marco.procedimento">
                                <i class="fa-solid fa-play fa-fw mr-3"></i>
                                <span class="text-muted small">
                                    {{ marco.procedimento.search }}
                                </span>

                                <a href="#" @click.prevent="exibir_info('Outros Procedimentos', marco.outros_proc_lista)" v-if="marco.outros_proc">
                                    <span class="badge badge-primary" title="Outros procedimentos">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                        {{ marco.outros_proc }}
                                    </span>
                                </a>
                            </div>
                            <div v-if="marco.estoque_solicitacoes">
                                <div v-for="(solic, isx) in marco.estoque_solicitacoes" :key="isx" title="Solicitação ao Estoque">
                                    <i class="fa-solid fa-dolly fa-fw mr-3"></i>
                                    <a href="#" @click.prevent="abrir_solicitacao(solic.numero)" class="card-link">
                                        <span class="small">
                                            {{ solic.numero }} 
                                        </span>
                                    </a>
                                </div>
                            </div>
                            <div v-if="marco.pagamento">
                                <div>
                                    <i class="fa-solid fa-dollar-sign fa-fw mr-3"></i>
                                    Pagamento #{{ marco.pagamento.id_pagamento_atendimento }}
                                    <ul class="mb-0">
                                        <li v-for="(itp, itx) in marco.pagamento.item_pagamento_atendimento_ativos" :key="itx">
                                            {{ itp.forma_pagamento.st_forma_pagamento }}
                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                            {{ $util.formatMoeda(itp.dc_valor) }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div v-if="marco.id_atendimento">
                                <a href="#" @click.prevent="abrir_atendimento(marco.id_atendimento)" class="card-link">
                                    #{{ marco.id_atendimento }}
                                </a>
                            </div>

                            <div v-else>
                                <a href="#" @click.prevent="abrir_marcacao(marco)" class="card-link">
                                    Ir para Recepção
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>

            <div class="d-flex" v-if="false">
                <print-export ref="print" printid="print-orcamento" :print_by_func="true" @beforeprint="imprimir" @afterprint="pos_imprimir()" />
                <button type="button" class="btn btn-outline-primary ml-1" data-toggle="tooltip" data-placement="top" title="Recalcular"
                    @click="recalcular()" :disabled="$store.state.loading"
                    v-if="pode_alterar_orcamento">
                    <div class="spinner-border spinner-border-sm" role="status" v-if="$store.state.loading">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <i class="fas fa-sync-alt mr-2" v-else></i>
                    Recalcular
                </button>
                <button type="button" class="btn btn-outline-primary ml-1" @click="fixar_plano()">
                    <i class="fas fa-border-all mr-2"></i>
                    Fixar Plano
                </button>
                <button type="button" class="btn btn-outline-success ml-1" @click="compartilhar()">
                    <i class="fas fa-share mr-2"></i>
                    Compartilhar
                </button>
                <az-submit class="ml-1" @click="salvar_orcamento_paciente()">
                    <i class="fas fa-file-invoice-dollar mr-2"></i>
                    Salvar
                </az-submit>

                <template v-if="!consultorio && ( !orcamento || orcamento.fl_ativo !== false )">

                    <template v-if="!is_lab || is_not_lab || !orcamento_convertido">

                        <button type="button" class="btn btn-outline-success ml-1" @click="agendar(true)">
                            <i class="fa fa-calendar-plus-o mr-2" aria-hidden="true"></i>
                            Agendar
                        </button>

                        <button type="button" class="btn btn-outline-success ml-1" @click="converter(true)">
                            <i class="fa fa-play mr-2" aria-hidden="true"></i>
                            Converter
                        </button>

                    </template>

                    <button type="button" class="btn btn-outline-success ml-1" @click="pagar()" v-if="id_orcamento && ( paciente || orcamento_convertido )">
                        <i class="fas fa-dollar-sign mr-2"></i>
                        {{ id_pagamento_atendimento ? 'Ver Pagamento' : 'Pagar' }}
                    </button>

                </template>
            </div>

            <div class="row mt-3">
                <div class="col col-12">
                    <az-input
                        sizing="sm"
                        type="checkbox-group"
                        label="Exibir instruções na impressão do orçamento"
                        v-model="exibir_inst" />
                </div>
            </div>

            <div class="row">
                <div class="col col-12">
                    <az-input
                        sizing="sm"
                        type="checkbox-group"
                        label="Exibir apenas os totais para o paciente"
                        v-model="exibir_apenas_total" />
                </div>
            </div>

            <div class="row">
                <div class="col col-12">
                    <az-input
                        sizing="sm"
                        type="checkbox-group"
                        label="Não exibir o valor individual de cada procedimento"
                        v-model="nao_exibir_valor_do_item" />
                </div>
            </div>

            <div class="row">
                <div class="col col-12">
                    <az-input
                        sizing="sm"
                        type="checkbox-group"
                        label="Exibir materiais/medicamentos/taxas detalhados"
                        v-model="exibir_mat_med_tx" />
                </div>
            </div>
            
            
        </div>

        <div v-if="comparar_com && comparar_com.length" class="mt-3">
            <small class="text-muted">Comparar Com...</small>
            <ul class="list-group">
                <li class="list-group-item d-flex justify-content-between" v-if="procedimentos && procedimentos.length">
                    <div>
                        {{ dados.plano.search }}
                    </div>
                    <div>
                        {{ $util.formatMoeda(total_orcado) }}
                        <span v-if="desconto">
                            <i class="fa fa-minus mx-1" aria-hidden="true"></i>
                            {{ $util.formatMoeda(valor_desconto) }} 
                            <i class="fas fa-equals mx-1"></i> 
                            {{ $util.formatMoeda(total_orcado - valor_desconto) }}
                        </span>
                    </div>
                </li>
                <li class="list-group-item d-flex justify-content-between" v-for="(item, idx) in comparar_com" :key="idx">
                    <div>
                        <a href="#" @click.prevent="remover_comparacao(idx)" class="text-danger mr-2">
                            <i class="fas fa-minus"></i>
                        </a>
                        {{ item.search }}
                    </div>
                    <div>
                        {{ $util.formatMoeda(total_comparacao(item.id_plano)) }}
                    </div>
                </li>
            </ul>
        </div>

        <div v-if="parcelamento > 1" class="alert alert-info d-flex justify-content-between mt-3">
            <div>
                Parcelamento em {{ parcelamento }} vezes de...
            </div>
            <div> 
                {{ $util.formatMoeda( (total_orcado - valor_desconto) / parcelamento ) }}
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="compartilharOrcamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ titulo_acao }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row justify-content-center" v-if="!fluxo">
                            <div class="col col-12 col-md-12 col-lg-8">
                                <div class="row d-flex justify-content-center">

                                    <div class="col">
                                        <a href="#" @click.prevent="startFluxo(2)" class="card border-0 card-templates dashcard card-link az-anime-surgir">
                                            <div class="card-body d-flex align-items-center flex-column text-center text-white atalho" style="--height: 400px;"
                                                :class="'bg-success'">
                                                <i class="fas fa-user-check fa-4x"></i>
                                                <div class="display-4 atalho-titulo mt-2">
                                                    <small>Paciente</small>
                                                </div>
                                            </div>
                                        </a>
                                    </div>

                                    <div class="col">
                                        <a href="#" @click.prevent="startFluxo(1)" class="card border-0 card-templates dashcard card-link az-anime-surgir">
                                            <div class="card-body d-flex align-items-center flex-column text-center text-white atalho" style="--height: 400px;"
                                                :class="'bg-danger'">
                                                <i class="fas fa-user-check fa-4x"></i>
                                                <div class="display-4 atalho-titulo mt-2">
                                                    <small class="text-nowrap text-truncate">Primeira Vez</small>
                                                </div>
                                            </div>
                                        </a>
                                    </div>

                                    <div class="col" v-if="acao == 'S' && sem_valor_sem_salvar && !block_nao_informado">
                                        <a href="#" @click.prevent="salvar_orcamento(true)" class="card border-0 card-templates dashcard card-link az-anime-surgir">
                                            <div class="card-body d-flex align-items-center flex-column text-center text-white atalho" style="--height: 400px;"
                                                :class="'bg-secondary'">
                                                <i class="fa-solid fa-users-slash fa-4x"></i>
                                                <div class="display-4 atalho-titulo mt-2">
                                                    <small class="text-nowrap text-truncate">Não Informado</small>
                                                </div>
                                            </div>
                                        </a>
                                    </div>

                                    
                                </div>
                            </div>
                        </div>
                        <template v-else>
                            <div class="d-flex flex-column" v-if="!id_orcamento">
                                <button type="button" class="btn btn-outline-secondary mb-3" @click="reiniciar_salvamento()">
                                    Voltar
                                </button>
                            </div>
                            <div class="row">
                                <div class="col col-12" v-if="fluxo == 2 && !id_orcamento">
                                    <az-input 
                                        placeholder="Informe o nome ou CPF do paciente..."
                                        icon="fas fa-user fa-fw"
                                        type="autocomplete" 
                                        optionsMode="aql"
                                        service="pacientes.index"
                                        optionsDisplay="search"
                                        :optionsParm2="{ mrc: true }"
                                        ref="info_paciente"
                                        v-model="paciente" 
                                        :optimized_ac="true"
                                        @input="selecionarPaciente()" />
                                </div>
                                <div class="col col-12" v-else-if="acao == 'G' && !paciente">
                                    <cadastro-temporario
                                        v-model="cadastro_temporario"
                                        :validate="validate"
                                        @selecionar="identificar_paciente" />
                                </div>
                                <div class="col col-12" v-else>
                                    <az-input
                                        placeholder="Informe o nome paciente..."
                                        icon="fas fa-user fa-fw"
                                        type="text" 
                                        :edicao="!id_orcamento || !paciente"
                                        v-model="dados_share.nome" />
                                </div>
                            </div>

                            <template v-if="dados_share.nome && dados_share.nome != 'NAO INFORMADO' && acao != 'G' && ( fluxo == 2 && paciente || fluxo == 1 )">
                                <div class="row mt-3">
                                    <div class="col col-12">
                                        <az-input 
                                            type="email"
                                            placeholder="Informe o e-mail..."
                                            icon="far fa-envelope-open fa-fw"
                                            v-model="dados_share.email" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col col-12">
                                        <az-input 
                                            type="fone"
                                            placeholder="Informe o número do celular..."
                                            icon="fas fa-mobile-alt fa-fw"
                                            required
                                            :validate="validate"
                                            v-model="dados_share.celular" />
                                    </div>
                                </div>
                                <div class="row" v-if="dados_share.telegram">
                                    <div class="col col-12">
                                        <az-input 
                                            type="label"
                                            label="Telegram Conectado!"
                                            icon="fab fa-telegram-plane fa-fw" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col col-12">
                                        <az-input 
                                            label="CPF"
                                            type="cpf"
                                            :compact="true"
                                            placeholder="CPF..."
                                            :validate="validate"
                                            v-model="dados_share.cpf" />
                                    </div>
                                </div>

                                <template v-if="acao == 'C'">
                                    <div class="d-flex flex-column mt-3">
                                        <az-submit color="outline-info" class="mb-1" v-if="dados_share.telegram"
                                            @click="enviar_pelo_telegram()">
                                            <i class="fab fa-whatsapp mr-2"></i>
                                            Enviar Orçamento pelo Telegram
                                        </az-submit>    
                                        <az-submit color="outline-primary" class="mb-1" v-if="dados_share.email"
                                            @click="enviar_por_email()">
                                            <i class="far fa-envelope-open mr-2"></i>
                                            Enviar Orçamento por e-mail
                                        </az-submit>    
                                        <a class="btn btn-outline-success mb-1" v-if="dados_share.celular" target="_blank" @click="enviar_pelo_whatsapp()">
                                            <i class="fab fa-whatsapp mr-2"></i>
                                            Enviar Orçamento pelo WhatsApp
                                        </a>    
                                        <button type="button" class="btn btn-outline-secondary mb-1" @click="copiar_clipboard()">
                                            <i class="fas fa-copy mr-2"></i>
                                            Copiar Texto do Orçamento
                                        </button>    
                                    </div>
                                </template>

                                <pre v-if="false">{{ dados_share }}</pre>
                                <pre v-if="false">{{ dados }}</pre>
                            </template>

                            <template v-if="orc_convert_unidades && fluxo && acao == 'G'">
                                <az-input
                                    class="mt-3"
                                    icon="fa fa-building fa-fw"
                                    placeholder="Selecione a Unidade..."
                                    type="select"
                                    required
                                    :validate="validate"
                                    :optionsList="lista_unidades"
                                    optionsData="id_unidade_operacao"
                                    v-model="selecao_id_unidade_operacao" />
                            </template>

                            <template v-if="fluxo && acao == 'G'">

                                <!-- Selecionar Procedimentos -->
                                <template v-if="orcamento && orcamento.vacinas && orcamento.vacinas.length">
                                    <div class="row my-3">
                                        <div class="col col-12">
                                            <az-input
                                                type="checkbox-group"
                                                :label="is_lab ? 'Selecionar procedimentos' : 'Selecionar procedimentos. Desmarque para lançar todos.'"
                                                v-model="selec_proc" />
                                        </div>
                                    </div>

                                    <table class="table table-sm table-hover" v-if="selec_proc">
                                        <thead>
                                            <th></th>
                                            <th>Descrição</th>
                                            <th class="text-right">Qtd</th>
                                            <th class="text-right">Agendado</th>
                                            <th class="text-right">Atendido</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(proc, ipx) in orcamento.vacinas" :key="ipx" :class="'table-' + proc.color">
                                                <td width="1%">
                                                    <input type="checkbox" v-model="proc.selecionado" :disabled="proc.in_quantidade <= proc.marcado">
                                                </td>
                                                <td>
                                                    {{ proc.search }}
                                                </td>
                                                <td class="text-right">{{ proc.in_quantidade }}</td>
                                                <td class="text-right">{{ proc.marcado }}</td>
                                                <td class="text-right">{{ proc.atendido }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </template>
                            </template>
                        </template>

                        <br><br><br><br><br><br><br><br>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-success" v-if="paciente && acao == 'A'" @click="agendar()">{{ titulo_acao }}</button>
                        
                        <az-submit v-else-if="fluxo && acao == 'G'" @click="converter()">{{ titulo_acao }}</az-submit>

                        <az-submit v-if="dados_share.nome && ( fluxo == 2 && paciente || fluxo == 1 ) && acao == 'S'" @click="salvar_orcamento()">
                            Salvar Orçamento
                        </az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Buscar Orçamentos -->
        <div class="modal fade" id="buscarOrcamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-total modal-dialog-scrollable" role="document">
                <div class="modal-content modal-content-total" v-if="busca_orc">
                    <div class="modal-header">
                        <h5 class="modal-title">Buscar Orçamentos</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <consultar-orcamentos ref="consorc" @selecionado="selecionar_orcamento" :paciente="paciente" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Seleção Profissional -->
        <div class="modal fade" id="selecMedicoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Selecionar Profissional</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info" v-if="proc_sel_medico && proc_sel_medico.procedimento">
                            {{ proc_sel_medico.procedimento.search }}
                        </div>

                        <az-empty-state 
                            v-if="!lista_medicos || !lista_medicos.length" 
                            icon="fa fa-user-md"
                            msg="Nenhum profissional identificado." />

                        <template v-else>
                            <div class="list-group">
                                <button type="button" class="list-group-item list-group-item-action" v-for="(medico, imx) in lista_medicos" :key="imx"
                                    @click="converter_selecao_medico(medico.medico_unidade.medico)">
                                    {{ medico.medico_unidade.medico.search }}
                                </button>
                            </div>
                        </template>

                        <pre class="alert alert-info" v-if="false">{{ lista_medicos }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="qtdeSessaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Sessões</h5>
                            <button type="button" class="close" aria-label="Close" data-dismiss="modal">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            type="number"
                            required
                            v-model="qtde_sessoes" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="selecionar_pacote (sel_pacote, qtde_sessoes)">Selecionar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Nova Agenda Direto -->
        <div class="modal fade" id="marcacaoDiretoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="agenda">
                    <div class="modal-header">
                        <h5 class="modal-title">Nova Marcação</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="!agenda.item.id_paciente">
                            <cadastro-temporario
                                v-model="agenda.item.cadastro_temporario"
                                :validate="validate"
                                @selecionar="identificar_paciente" />
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"   
                                    label="Data"
                                    type="date"
                                    :validate="validate"
                                    required
                                    v-model="agenda.data" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input   
                                    sizing="sm"
                                    label="Hora"
                                    type="time"
                                    :validate="validate"
                                    required
                                    v-model="agenda.hora" />
                            </div>
                        </div>

                        <div class="mt-3" v-if="orcamento && orcamento.vacinas && orcamento.vacinas.length">

                            <div class="row mb-3">
                                <div class="col col-12">
                                    <az-input
                                        type="checkbox-group"
                                        label="Selecionar procedimentos. Desmarque para agendar todos."
                                        v-model="selec_proc" />
                                </div>
                            </div>

                            <table class="table table-sm" v-if="selec_proc">
                                <thead>
                                    <th></th>
                                    <th>Descrição</th>
                                    <th class="text-right">Qtd</th>
                                    <th class="text-right">Agendado</th>
                                    <th class="text-right">Atendido</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(proc, ipx) in orcamento.vacinas" :key="ipx" :class="'table-' + proc.color">
                                        <td width="1%">
                                            <input type="checkbox" v-model="proc.selecionado" :disabled="proc.in_quantidade <= proc.marcado">
                                        </td>
                                        <td>
                                            {{ proc.search }}
                                        </td>
                                        <td class="text-right">{{ proc.in_quantidade }}</td>
                                        <td class="text-right">{{ proc.marcado }}</td>
                                        <td class="text-right">{{ proc.atendido }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <br><br><br><br><br><br><br><br>

                        <pre v-if="1==0 && orcamento">{{ orcamento.vacinas }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="ir_para_agenda()">Ir Para Agenda</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_agenda()">Incluir</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Selecionar Profissional -->
        <div class="modal fade" id="selecaoProfissionalModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="selecao_profissional">
                    <div class="modal-header">
                        <h5 class="modal-title">Selecionar Profissional</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="procedimentos && procedimentos[0] && procedimentos[0].procedimento">
                            <div class="col col-12">
                                <az-input
                                    label="Médico"
                                    type="autocomplete" 
                                    placeholder="Selecione..."
                                    optionsMode="aql"
                                    service="medicos.index"
                                    optionsName="medicos-cadastro-agenda"
                                    :optionsSync="true"
                                    :optionsParm="{ 
                                        ativos: true,
                                        id_procedimento: procedimentos[0].procedimento.id_procedimento, 
                                    }"
                                    v-model="procedimentos[0].medico" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="agendar()" :disable="procedimentos[0].medico">Pular</button>
                        <az-submit @click="agendar(true)">Agendar</az-submit>
                    </div>
                </div>
            </div>
        </div>
                        
        <pre class="alert alert-info" v-if="false">{{ procedimentos }}</pre>

        <template v-if="acao_anexar && orcamento && orcamento.arquivos">
            <az-file-upload
                ref="upload"
                @refresh="carregar_arquivos()"
                :multiple="true"
                :arquivos="orcamento.arquivos"
                :parms="{ 
                    model_type: 'orcamento', 
                    model_id: orcamento.id_orcamento, 
                    id_paciente: orcamento.id_paciente,
                }"
                @ocr="atualizar_ocr" />
        </template>

        <br><br><br><br><br>

        <nav class="navbar fixed-bottom navbar-light bg-light" id="barra-orcamento">
            <div>
                <button class="btn btn-primary btn-sm mr-2" type="button" @click="buscar_orcamento()">
                    <span class="d-block d-lg-none">
                        <i class="fa-solid fa-arrows-rotate"></i>
                    </span>
                    <span class="d-none d-lg-block">
                        Buscar
                    </span>
                </button>
                <span>
                    {{ nome_paciente }}
                    <span v-if="id_orcamento && nome_paciente">
                        <i class="fas fa-caret-right mx-2"></i>
                    </span>
                    <span v-if="id_orcamento">
                        #{{ id_orcamento }}
                    </span>
                    <span v-if="prazo_final" class="ml-2" title="Prazo">
                        <i class="fa-regular fa-calendar-check ml-2"></i>
                        {{ $util.getFormatDate(prazo_final) }}
                    </span>
                </span>
            </div>
            <div class="ml-3 d-flex">
                <template v-if="procedimentos && procedimentos.length">
                    <div class="spinner-border spinner-border-sm mr-2" role="status" v-if="$store.state.loading">
                        <span class="sr-only">Loading...</span>
                    </div>

                    <!-- Prazos -->
                    <button type="button" class="btn btn-outline-secondary btn-sm mr-1" @click="get_prazos()" title="Prazos" v-if="is_lab">
                        <i class="fa-regular fa-calendar-check"></i>
                    </button>

                    <!-- Documentos -->
                    <button type="button" class="btn btn-outline-warning btn-sm mr-1" @click="novo_documento()" title="Novo Documento" v-if="id_orcamento">
                        <i class="far fa-file-alt"></i>
                    </button>

                    <!-- Impressão -->
                    <print-export ref="print" printid="print-orcamento" sizing="sm" :nodropdown="true" :print_by_func="true" @beforeprint="imprimir" @afterprint="pos_imprimir()" />

                    <!-- Clonar -->
                    <button type="button" class="btn btn-outline-primary btn-sm ml-1" @click="clonar_orcamento()" title="Clonar Orçamento" v-if="id_orcamento">
                        <i class="fa-solid fa-clone"></i>
                    </button>

                    <!-- Split / Dividir -->
                    <button type="button" class="btn btn-outline-primary btn-sm ml-1" @click="separar_orcamento()" title="Separar Orçamento" v-if="id_orcamento">
                        <i class="fa-solid fa-split"></i>
                    </button>
                    
                    <!-- Opções -->
                    <template v-if="!consultorio">
                        <button type="button" class="btn btn-outline-primary btn-sm ml-1" title="Recalcular"
                            @click="recalcular()" :disabled="$store.state.loading"
                            v-if="pode_alterar_orcamento">
                            <span class="d-block d-lg-none">
                                <i class="fa-solid fa-calculator"></i>
                            </span>
                            <span class="d-none d-lg-block">
                                <i class="fa-solid fa-calculator mr-2"></i>
                                Recalcular
                            </span>
                        </button>
                        <button type="button" class="btn btn-outline-primary btn-sm ml-1" @click="fixar_plano()">
                            <span class="d-block d-lg-none">
                                <i class="fas fa-border-all"></i>
                            </span>
                            <span class="d-none d-lg-block">
                                <i class="fas fa-border-all mr-2"></i>
                                Fixar Plano
                            </span>
                        </button>
                    </template>

                    <template v-if="orcamento && orcamento.dt_validade < $util.hoje() && !orcamento_convertido">
                        <!-- Orçamento Vencido -->
                    </template>

                    <template v-else>

                        <az-submit class="ml-1 btn-sm" @click="salvar_orcamento_paciente()" :nospinner="true">
                            <span class="d-block d-lg-none">
                                <i class="fas fa-file-invoice-dollar"></i>
                            </span>
                            <span class="d-none d-lg-block">
                                <i class="fas fa-file-invoice-dollar mr-2"></i>
                                Salvar
                            </span>
                        </az-submit>

                        <template v-if="( !orcamento || orcamento.fl_ativo !== false )">
                            <button type="button" class="btn btn-outline-success btn-sm ml-1" @click="compartilhar()">
                                <span class="d-block d-lg-none">
                                    <i class="fas fa-share"></i>
                                </span>
                                <span class="d-none d-lg-block">
                                    <i class="fas fa-share mr-2"></i>
                                    Compartilhar
                                </span>
                            </button>
                            <template v-if="!consultorio">
                                <template v-if="!is_lab || is_not_lab || !orcamento_convertido">
                                    <button type="button" class="btn btn-outline-success btn-sm ml-1" @click="agendar(true)">
                                        <span class="d-block d-lg-none">
                                            <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
                                        </span>
                                        <span class="d-none d-lg-block">
                                            <i class="fa fa-calendar-plus-o mr-2" aria-hidden="true"></i>
                                            Agendar
                                        </span>
                                    </button>
                                    <button type="button" class="btn btn-outline-success btn-sm ml-1" @click="converter(true)">
                                        <span class="d-block d-lg-none">
                                            <i class="fa fa-play" aria-hidden="true"></i>
                                        </span>
                                        <span class="d-none d-lg-block">
                                            <i class="fa fa-play mr-2" aria-hidden="true"></i>
                                            Converter
                                        </span>
                                    </button>
                                </template>
                                <button type="button" class="btn btn-outline-success btn-sm ml-1" @click="pagar()" v-if="id_orcamento && ( paciente || orcamento_convertido )">
                                    <span class="d-block d-lg-none">
                                        <i class="fas fa-dollar-sign"></i>
                                    </span>
                                    <span class="d-none d-lg-block">
                                        <i class="fas fa-dollar-sign mr-2"></i>
                                        {{ id_pagamento_atendimento ? 'Ver Pagamento' : 'Pagar' }}
                                    </span>
                                </button>
                            </template>
                        </template>

                    </template>
                </template>
            </div>
        </nav>

        <!-- Prazos -->
        <div class="modal fade" id="prazosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Prazos</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="!prazos">
                            <div class="spinner-border mr-2" role="status" v-if="$store.state.loading">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>

                        <div v-else-if="prazos && prazos.status == 'success'">

                            <table class="table mt-3 mb-0">
                                <tbody>
                                    <tr v-for="(exames, prazo, chave) in lista_prazos" :key="chave">
                                        <td width="1%">{{ $util.getFormatDate(prazo) }}</td>
                                        <td width="1%"><span class="badge badge-secondary mr-1">{{ exames.length }}</span></td>
                                        <td>
                                            <span class="badge badge-pill mr-1" 
                                                :class="( exame.terc == 'S' ) ? 'badge-info' : 'badge-primary'"
                                                :title="( exame.nome ) + ( exame.terc == 'S' 
                                                    ? ' / Terceirizado' + ( exame.terc_sigla ? ' (' + exame.terc_sigla + ')' : '' )
                                                    : '' 
                                                )"
                                                v-for="(exame, iex) in exames" :key="iex">
                                                {{ exame.sigla }}
                                                <span class="ml-1" v-if="exame.terc == 'S'">
                                                    <i class="fa-solid fa-location-pin"></i>
                                                </span>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                        <div v-else class="alert alert-danger">
                            {{ prazos }}
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Documentos -->
        <documento ref="documento" :orcamento="true" :recepcao="true" refresh="imprimir_documento" />

        <!-- Aprovação de Desconto -->
        <orcamento-aprovacao-desconto ref="aprovacao" />

        <!-- Help de Exames -->
        <help-exame-klis ref="help" />

        <!-- Ciente Instruções -->
        <ciente-instrucoes ref="ciente" @ciente="ciente()" />

        <!-- Orçamento / Separar -->
        <orcamento-split ref="split" @refresh="refresh_orcamento" />

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import PrintExport from "../../shared/PrintExport.vue";
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import AzInstrucoes from '../../util/AzInstrucoes.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import ConsultarOrcamentos from './ConsultarOrcamentos.vue';
import CadastroTemporario from './CadastroTemporario.vue';
import MedicoSolicitante from '../../shared/MedicoSolicitante.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import Documento from '../consultorio/Documento.vue';
import Multiselect from 'vue-multiselect';
import OrcamentoAprovacaoDesconto from './OrcamentoAprovacaoDesconto.vue';
import HelpExameKlis from '../recepcao/HelpExameKlis.vue';
import CienteInstrucoes from '../recepcao/CienteInstrucoes.vue';
import OrcamentoSplit from './OrcamentoSplit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data() { 
        return { 
            procedimentos: [],
            imprimindo: false, 
            fluxo: null, 
            paciente: "", 
            orcamento: null, 
            dados_share: { 
                nome: "", 
                email: "",
                celular: "",
                cpf: "",
                telegram: "", 
                telegram_conectado: "Conectado no Telegram",
            },
            info: { 
                medico_solicitante: null
            },
            comparar_com: [],
            nome_paciente: "", 
            novoComponente: "",
            linha_incluir_consumo: null, 
            validate: false, 
            id_orcamento: null, 
            id_pagamento_atendimento: null, 
            exibir_inst: this.$util.getCookie('orc-exibir-inst') == 'N' ? false : true, 
            exibir_mat_med_tx: this.$util.getCookie('orc-matmed') == 'S' ? true : false, 
            nao_exibir_valor_do_item: this.$util.getCookie('orc-block-vi') == 'S' ? true : false, 
            exibir_apenas_total: false, 
            busca_orc: false,
            acao: 'C', 
            abrindo_orcamento: false, 
            observacoes: "", 
            desconto: 0, 
            tipo_desconto: 'P',
            titulo: "", 
            parcelamento: "", 
            cadastro_temporario: {}, 
            lista_medicos: null,
            nova_qtde: null, 
            indexProcPacote: null, 
            pacotes: null, 
            qtde_sessoes: null, 
            cabecalho: null, 
            solicitante: null,
            agenda: null, 
            atender_proc_sem_agenda: false, 

            selecao_profissional: false,
            id_medico_agenda: null,

            nao_imprimir_orcamento_sem_salvar: false, 
            sem_valor_sem_salvar: false, 
            removendo: false, 

            selec_proc: true, 

            acao_anexar: false, 
            agenda_procs: [], 

            prazos: null, 

            selecao_id_unidade_operacao: "", 
            id_atendimento: null, 

            js_classes: [], 
            options_classes: [], 

            proc_sel_medico: null, 
            desconto_tipo_ident: false, 
            desconto_tipo: "", 
            obs_padrao: "", 
            block_nao_informado: false, 
            lista_lanc: [], 
        }
    },

    props: ['value', 'dados', 'orc_convert_unidades', 'regioes'],

    components: { 
        PrintExport, 
        CabecalhoGenerico,
        AzInstrucoes, 
        AzInput,
        AzSubmit,
        AzEmptyState,
        ConsultarOrcamentos, 
        CadastroTemporario, 
        MedicoSolicitante, 
        AzFileUpload, 
        Documento, 
        Multiselect, 
        OrcamentoAprovacaoDesconto, 
        HelpExameKlis, 
        CienteInstrucoes, 
        OrcamentoSplit, 
        AzAuditLogButton, 
    },

    watch: { 
        procedimentos: { 
            handler: function () { 
                this.prazos = null;
            },
            deep: true
        },
    },

    computed: { 
        pode_ver_valor: function () { 
            return !this.sem_valor_sem_salvar || this.id_orcamento;
        },

        tem_prazo: function () { 
            return ( this.procedimentos && this.procedimentos.find(item => item.procedimento && item.procedimento.in_prazo_entrega) ) ? true : false;
        },
        consultorio: function () { 
            return this.$route.name == 'corcamento';
        },

        lista_unidades: function () {
            return _.orderBy(
                this.$util.unidades_com_tags(false, true).filter(item => !item.fl_unidade_adm),
                'st_nome'
            );
        },

        prazo_final: function () { 
            if ( this.prazos && this.prazos.status == 'success' ) { 
                let prazo = _.maxBy(this.prazos.lista, item => item.prazo ? item.prazo.slice(0,10) : null);
                return ( prazo && prazo.prazo ) ? prazo.prazo.slice(0,10) : '';
            }

            return '';
        },

        lista_prazos: function () { 
            if ( !this.prazos ) { 
                return null;
            }

            return _.groupBy(
                _.orderBy(
                    this.prazos.lista, 
                    item => { 
                        return item.prazo ? item.prazo.slice(0,10) : '?';
                    }
                ),
                (item) => { 
                    return item.prazo ? item.prazo.slice(0,10) : '?';
                }
            );
        },

        is_lab: function () { 
            if ( !this.procedimentos )
                return false;

            return this.procedimentos.find(item => item.procedimento && item.procedimento.id_especialidade == 2) ? true : false;
        },

        is_not_lab: function () { 
            if ( !this.procedimentos )
                return false;

            return this.procedimentos.find(item => item.procedimento && item.procedimento.id_especialidade != 2) ? true : false;
        },

        is_vacina: function () { 
            if ( !this.procedimentos )
                return false;

            return this.procedimentos.find(item => item.procedimento && item.procedimento.id_classe_procedimento == 19) ? true : false;
        },

        total_coparticipacao: function () { 
            if ( !this.procedimentos )
                return false;

            return this.procedimentos.reduce((total, carry) => { 
                if ( !carry.atendimento_procedimento_consumos ) { 
                    return total; 
                }

                let valor = carry.atendimento_procedimento_consumos.filter(consumo => consumo.copart)
                    .reduce((total_consumo, carry_consumo) => total_consumo + ( carry_consumo.dc_valor_unitario ? parseFloat(carry_consumo.dc_valor_unitario) : 0 ), 0);
                    
                return total + valor; 
            }, 0); 
        },

        orcamento_convertido: function () { 
            return ( this.orcamento && this.orcamento.id_orcamento == this.id_orcamento && this.orcamento.marcacoes && this.orcamento.marcacoes.length )
                ? true 
                : false;
        },

        valor_desconto: function () { 
            if ( this.tipo_desconto == 'V' )
                return this.desconto;

            return ( this.desconto > 0 ) ? Math.round ( this.total_orcado * this.desconto ) / 100 : 0;
        },

        total_orcado: function () { 
            if ( this.total_coparticipacao ) { 
                return this.total_coparticipacao; 
            }

            return this.procedimentos.reduce((total, carry) => { 
                return total 
                    + ( carry.atendimento_pacote ? carry.atendimento_pacote.dc_valor_pacote : ( carry.dc_valor_procedimento * carry.in_quantidade) )
                    + carry.atendimento_procedimento_consumos.reduce((totalc, carryc) => { 
                        return totalc + (carryc.dc_valor_unitario * carryc.in_quantidade)
                    }, 0); 
            }, 0);
        },

        titulo_acao: function () { 
            switch (this.acao) {
                case 'A': return 'Agendar';
                case 'S': return 'Salvar Orçamento';
                case 'G': return 'Converter em Atendimento';
                default: return 'Compartilhar';
            }
        },

        tem_cabecalho_com_nome: function () { 

            if ( this.cabecalho && this.cabecalho.fl_campos_cabecalho && this.cabecalho.js_campos_cabecalho ) { 

                let teste = this.cabecalho.js_campos_cabecalho.find((campo) => { 
                    return campo && campo.campo == 'paciente.st_nome';
                });

                return teste ? true : false; 

            }

            return false;

        },

        pode_alterar_orcamento: function () { 

            if ( this.id_orcamento && this.orcamento && this.orcamento.msg_editar ) { // this.id_pagamento_atendimento 
                return false;
            }

            return true;

        }

    },

    methods:  {
        refresh_orcamento (id_orcamento) { 

            console.log('refresh_orcamento', id_orcamento);

            this.$nextTick(() => { 
                this.$util.load(this, { 
                    service: 'orcamentos',
                    func: 'show', 
                    parms: {  
                        id: id_orcamento, 
                        sel_orcamento: true, 
                    },
                    loadTo: res => { 
                        this.selecionar_orcamento(res);
                    }
                });
                
            });

        },

        separar_orcamento () { 
            if ( !this.orcamento || !this.orcamento.id_orcamento ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Separar Orçamento",
                    detail: "O orçamento precisa estar salvo pra ser separado.",
                    life: 5000
                });
                return; 
            }

            this.$refs.split.abrir(this.orcamento);
        },

        ciente () { 
            this.salvar_orcamento(false, true);
        },

        atualizar_ocr (ocr) { 
            this.orcamento.ocr_codigos = ocr.ocr_codigos;
        },

        incluir_codigos(codigos) {
            this.$parent.focusOn('info_procedimento');

            let info_proc = this.$parent.$refs.info_procedimento;

            if ( Array.isArray(info_proc) ) {
                info_proc = info_proc[0];
            }

            if ( info_proc ) { 
                console.log('aqui');
                info_proc.$refs.input.focus ();
                info_proc.search = codigos;
                info_proc.onChange();
            }
        },

        clonar_orcamento () { 
            if ( !confirm('Confirma clonar o orçamento #' + this.id_orcamento + '?') ) {
                return;
            }

            this.id_orcamento = null; 
            this.orcamento.id_orcamento = null;
            this.orcamento.arquivos = []; 
            this.orcamento.marcacoes = [];

            this.$toast.add({
                severity: "success",
                summary: "Atenção",
                detail: "Orçamento clonado. \nLembre-se de salvar o novo orçamento, após as alterações realizadas.",
                life: 5000
            });
        },

        abrir_help (item) { 
            if ( !item || !item.procedimento || !item.procedimento.id_procedimento ) {
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Selecione um procedimento para abrir o help.",
                    life: 5000
                });
                return;
            }

            this.$refs.help.abrir_procedimento(item.procedimento.id_procedimento);
        },

        aprovar_desconto () { 
            this.$refs.aprovacao.abrir(this.orcamento);
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.js_classes )
                this.js_classes = [];

            this.js_classes.push(newTag);
        },

        toggle (orcamento) { 
            this.$util.toggle(this, { 
                service: 'orcamentos',
                dados: orcamento,
            });
        },

        novo_documento() {
            this.$refs.documento.novoDocumento(this.orcamento);
        },

        get_prazos () { 
            this.prazos = null;

            $('#prazosModal').modal('show');

            this.$util.load(this, {
                service: 'procedimentos',
                func: 'prazos',
                parms: {
                    id_plano: this.dados.plano.id_plano,
                    id_unidade_operacao: this.dados.unidade_operacao ? this.dados.unidade_operacao.id_unidade_operacao : null,
                    id_procedimentos: this.procedimentos.map(item => item.procedimento ? item.procedimento.id_procedimento : item.id_procedimento), 
                },
                loadTo: res => { 
                    this.prazos = res;
                }
            });
        },

        abrir_solicitacao (id) { 
            this.$util.abrir_solicitacao(this, id);
        },

        exibir_info (titulo, texto) { 
            this.$toast.add({
                severity: "info",
                summary: titulo,
                detail: texto,
                life: 10000
            });
        },

        abrir_anexar_arquivo() {
            this.acao_anexar = true;

            if ( this.orcamento.arquivos && this.orcamento.arquivos.length && !this.orcamento.arquivos.find(arq => arq.arquivo) ) {
                this.carregar_arquivos(true);
                return;
            }

            this.$nextTick(() => {
                this.$refs.upload.abrir();
            });
        },

        carregar_arquivos (abrir = false) {

            this.$store.commit('loading', true);

            this.$util.loadItem(this, {
                service: 'arquivos',
                func: 'links',
                parms: {
                    id: this.orcamento.id_orcamento,
                    type: 'orcamento',
                }
            })
            .then(res => {
                this.orcamento.arquivos = res;

                if ( abrir ) {
                    this.$nextTick(() => {
                    this.$refs.upload.abrir();
                    });
                }
            })
            .finally(() => {
                this.$store.commit('loading', false);
            });

        },

        abrir_atendimento (id) { 
            this.$util.abrir_atendimento(this, id);
        },

        abrir_marcacao (marcacao) { 
            this.$router.push({ name: 'recepcao', params: { search: 'M' + marcacao.id_marcacao } });
        },  

        retirar_pacote (item) { 
            item.atendimento_pacote = null;
            this.$forceUpdate();
        },

        selecionar_pacote(pacote, total = null, calculado = false, valor = null) {

            if ( pacote && pacote.pacote && pacote.pacote.fl_combo && pacote.pacote.fl_combo_pacote && !calculado ) {

                /*
                let proc = {
                    procedimento: pacote.pacote.procedimento,
                }
                */

                if ( pacote.pacote.fl_particular ) {
                    this.selecionar_pacote(pacote, total, true, pacote.pacote.dc_valor);
                } else {
                    /*
                    this.recalc_preco_cirurgia(proc, () => {
                        this.selecionar_pacote(pacote, total, true, proc.dc_valor_procedimento);
                    });
                    */
                }

                return;

            }

            if ( pacote.pacote.fl_qtde_variada && !total ) {
                this.sel_pacote = pacote;
                this.qtde_sessoes = pacote.in_quantidade;
                $('#qtdeSessaoModal').modal('show');
                return;
            } else if ( pacote.pacote.fl_qtde_variada && total ) {
                pacote.in_quantidade = total;
                $('#qtdeSessaoModal').modal('hide');
            }

            this.procedimentos[this.indexProcPacote].total_sessao = pacote.in_quantidade;
            this.procedimentos[this.indexProcPacote].atendimento_procedimento_consumos = [];

            /*
            if ( !pacote.pacote.fl_cobrar_mat_separado && this.dados.atendimento.atendimento_procedimentos[this.indexProcPacote].atendimento_procedimento_consumos ) {

                if (  !this.dados.atendimento.atendimento_procedimentos[this.indexProcPacote].id_atendimento_procedimento ) {
                    this.dados.atendimento.atendimento_procedimentos[this.indexProcPacote].atendimento_procedimento_consumos = [];
                } else {
                    this.dados.atendimento.atendimento_procedimentos[this.indexProcPacote].atendimento_procedimento_consumos.forEach(consumo => consumo.excluido = true);
                }

            }
            */

            if ( !valor ) {

                if ( this.dados.plano.id_operadora == 1 && pacote.pacote.pacote_sessao_valores ) {
                    let sessao_valor = pacote.pacote.pacote_sessao_valores.find(psv => psv.id_plano == this.dados.plano.id_plano);

                    if ( sessao_valor ) {
                        valor = sessao_valor.dc_valor * ( pacote.pacote.fl_qtde_variada ? pacote.in_quantidade : 1 );
                    }
                }

            }

            this.$set(this.procedimentos[this.indexProcPacote], 'atendimento_pacote', {
                in_quantidade_items: total,
                dc_valor_pacote: valor
                    ? valor
                    : (
                        this.dados.plano.id_operadora == 1 
                            ? ( pacote.pacote.dc_valor * ( pacote.pacote.fl_qtde_variada ? pacote.in_quantidade : 1 ) )
                            : this.procedimentos[this.indexProcPacote].dc_valor_procedimento *
                                pacote.in_quantidade
                    ),
                search: pacote.search ? pacote.search : pacote.pacote.search, 
                id_pacote: pacote.id_pacote, 
                id_procedimento_pacote: pacote.id_procedimento_pacote, 
            });

            /*
            this.procedimentos[this.indexProcPacote].atendimento_pacote = {
                in_quantidade_items: total,
                dc_valor_pacote: valor
                    ? valor
                    : (
                        this.dados.plano.id_operadora == 1 
                            ? ( pacote.pacote.dc_valor * ( pacote.pacote.fl_qtde_variada ? pacote.in_quantidade : 1 ) )
                            : this.procedimentos[this.indexProcPacote].dc_valor_procedimento *
                                pacote.in_quantidade
                    ),
                search: pacote.pacote.search, 
            };
            */

            this.indexProcPacote = null;

            this.$forceUpdate();

            $('.modal').modal('hide');

        },

        ver_pacotes (pacotes, index) {
            this.indexProcPacote = this.pacotes ? null : index;
            this.pacotes = this.pacotes ? null : pacotes;
        },

        editar_qtde (consumo) { 
            this.nova_qtde = consumo.in_quantidade;
            this.consumo_sel = consumo; 

            $('#editarQtdeModal').modal('show');
        },

        pagar () { 
            this.$router.push({ name: 'pagamentos', params: { id_orcamento: this.id_orcamento }});
        },

        identificar_paciente () { 
            //
        },

        get_info_orcamento () { 

            if ( !this.dados.unidade_operacao ) { 
                if ( this.$util.unidades_com_tags(false, false).length == 1 ) { 
                    this.dados.unidade_operacao = _.first(this.$util.unidades_com_tags(false, false));
                }
            }

            if ( ( !this.paciente || !this.paciente.id_pessoa ) && !this.cadastro_temporario.st_nome ) { 
                this.cadastro_temporario.st_nome = this.nome_paciente;
                this.cadastro_temporario.st_email = this.dados_share.email;
                this.cadastro_temporario.st_celular = this.dados_share.celular;
                this.cadastro_temporario.st_cpf = this.dados_share.cpf;
            } 
            
            return { 
                st_titulo: this.dados_share.nome,  
                id_paciente: this.paciente ? this.paciente.id_pessoa : null,  
                id_orcamento: this.id_orcamento, 
                id_plano: this.dados.plano.id_plano,
                id_unidade_operacao: this.dados.unidade_operacao ? this.dados.unidade_operacao.id_unidade_operacao : null,
                js_procedimentos: this.procedimentos, 
                st_nome: this.dados_share.nome,
                st_email: this.dados_share.email,
                st_celular: this.dados_share.celular,
                st_cpf: this.dados_share.cpf, 
                st_observacoes: this.observacoes, 
                dc_desconto: this.desconto,
                ch_tipo_desconto: this.tipo_desconto, 
                paciente: this.paciente, 
                cadastro_temporario: this.cadastro_temporario, 
                plano: this.dados.plano,
                unidade_operacao: this.dados.unidade_operacao, 
                fluxo: this.fluxo, 
                id_pagamento_atendimento: this.id_pagamento_atendimento,
                solicitante: this.info ? this.info.medico_solicitante : null,
                js_outros_campos: { 
                    id_regiao_cd: this.dados.regiao_cd ? this.dados.regiao_cd.id_regiao_cd : null,
                    qt_pac: this.dados.qt_pac, 
                },
            };
        },

        ir_para_agenda() { 

            $('[data-toggle="tooltip"]').tooltip("dispose");

            let lista;

            if ( this.selec_proc && this.orcamento.vacinas && this.orcamento.vacinas.length ) { 
                if ( !this.orcamento.vacinas.find (item => item.selecionado) ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Ir para Agenda",
                        detail: "Selecione os itens desejados.",
                        life: 5000
                    });

                    return;
                }

                lista = this.orcamento.vacinas;
            }

            $('.modal').modal('hide');
            
            const info = this.get_info_orcamento();

            let filtro_itens = lista ? lista.filter(item => !item.selecionado).map(item => item.id_procedimento) : [];

            let is_cirurgia = info.js_procedimentos 
                ? ( info.js_procedimentos.find(item => item.procedimento.id_classe_procedimento == 2
                    && !filtro_itens.includes(item.procedimento.id_procedimento)) ? true : false )
                : false;

            if ( is_cirurgia ) { 
                if ( !confirm('Deseja agendar a cirurgia, pelo módulo de centro cirúrgico?') ) { 
                    is_cirurgia = false;
                }
            }

            if ( is_cirurgia ) { 

                this.$nextTick(() => {
                    this.$router.push({
                        name: "centro-cirurgico",
                        params: { aba: 'marcacao', info_orcamento: this.agenda ? this.agenda.item : info, agenda_procs: lista,  }
                    });
                });

            } else { 

                this.$nextTick(() => {
                    this.$router.push({
                        name: "call-center",
                        params: { info_orcamento: this.agenda ? this.agenda.item : info, agenda_procs: lista,  }
                    });
                });

            }
        },

        agendar(start = false) {
            $('[data-toggle="tooltip"]').tooltip("dispose");
            $('.modal').modal('hide');

            const info = this.get_info_orcamento();

            if ( this.atender_proc_sem_agenda ) { 

                if ( !info.id_unidade_operacao ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Necessário selecionar a unidade desejada.",
                        life: 5000
                    });
                    return;
                }

                if ( start && !_.get(info, 'js_procedimentos.0.medico') ) { 
                    this.id_medico_agenda = "";
                    this.selecao_profissional = true;
                    
                    $('#selecaoProfissionalModal').modal('show');

                    return;
                }

                if ( !info.id_orcamento ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Necessário salvar o orçamento para gerar o agendamento.",
                        life: 5000
                    });
                    return;
                }

                if ( this.orcamento && this.orcamento.marcacoes && this.orcamento.marcacoes.length && !this.is_vacina && !this.atender_proc_sem_agenda ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Agendamento já realizado.",
                        life: 5000
                    });
                    return;
                }

            }

            if ( start && info.id_orcamento ) { 
                start = false;
            }

            if ( start || ( !info.id_orcamento && !info.id_paciente && this.fluxo != 1 ) ) { 
                this.acao = 'A';
                $('#compartilharOrcamentoModal').modal('show');          

                return;
            }

            if ( this.atender_proc_sem_agenda ) { 

                if ( !info.id_unidade_operacao ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Necessário selecionar a unidade desejada.",
                        life: 5000
                    });
                    return;
                }

                this.agenda = { 
                    item: _.cloneDeep(info),
                    data: this.$util.hoje(),
                    hora: this.$util.agora().substr(0,5),
                };

                this.validate = false;

                this.agenda_procs = this.procedimentos.map(item => { 
                    return { 
                        id_procedimento: item.procedimento.id_procedimento,
                        search: item.procedimento.search,
                        id_classe_procedimento: item.procedimento.id_classe_procedimento, 
                        selecionado: false, 
                    };
                });
                
                this.$nextTick(() => {
                    $('#marcacaoDiretoModal').modal('show');
                });

            } else { 

                const is_cirurgia = _.get(info, 'js_procedimentos.0.procedimento.id_classe_procedimento') == 2;

                if ( is_cirurgia ) { 

                    this.$nextTick(() => {
                        this.$router.push({
                            name: "centro-cirurgico",
                            params: { aba: 'marcacao', info_orcamento: info }
                        });
                    });

                } else { 
                
                    this.$nextTick(() => {
                        this.$router.push({
                            name: "call-center",
                            params: { info_orcamento: info }
                        });
                    });

                }

            }

        },

        salvar_agenda () { 
            if ( !_.cloneDeep(_.get(this.agenda.item, 'js_procedimentos.0.medico')) ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Necessário selecionar o profissional desejado.",
                    life: 5000
                });
                return;
            }

            let info = { 
                procedimentos: [ 
                    { 
                        procedimento: _.cloneDeep(_.get(this.agenda.item, 'js_procedimentos.0.procedimento')),
                        medico: _.cloneDeep(_.get(this.agenda.item, 'js_procedimentos.0.medico')),
                        plano: _.cloneDeep(this.agenda.item.plano),
                        data: this.agenda.data, 
                        hora: this.agenda.hora,
                        extra: false, 
                        ordem_chegada: true, 
                        remarcacao: null,
                        id_unidade_operacao: this.agenda.item.id_unidade_operacao,
                        id_agenda: null,
                        outros_procedimentos: this.agenda.item.js_procedimentos.slice(1).map(proc => { 
                            if ( proc.procedimento ) { 
                                return { 
                                    id_procedimento: proc.procedimento.id_procedimento,
                                    st_procedimento: proc.procedimento.st_procedimento,
                                    id_especialidade: proc.procedimento.id_especialidade,
                                    id_classe_procedimento: proc.procedimento.id_classe_procedimento, 
                                    search: proc.procedimento.search,
                                    in_quantidade: proc.in_quantidade,
                                };    
                            } else { 
                                return { 
                                    id_procedimento: proc.id_procedimento,
                                    st_procedimento: proc.st_procedimento,
                                    id_especialidade: proc.id_especialidade,
                                    id_classe_procedimento: proc.id_classe_procedimento, 
                                    search: proc.search,
                                    in_quantidade: proc.in_quantidade,
                                };
                            }
                        }),
                    },
                ],
                fl_tele_atendimento: false,
                inicio: '00:00',
                termino: '00:00',
                remarcacao: null,
                id_orcamento: this.agenda.item.id_orcamento,
                lista_de_espera: false,
                origem: 'orcamento',
            };

            if ( this.agenda.item.id_paciente ) { 
                info.paciente = _.cloneDeep(this.agenda.item.paciente);
            } else { 
                info.cadastro_temporario = _.cloneDeep(this.agenda.item.cadastro_temporario);
            }

            this.$util.atualizar(this, { 
                service: 'agendas',
                func: 'store',
                dados: info,
                modal: 'marcacaoDiretoModal',
                toast: true, 
                msg: 'Agendamento realizado.',
                callback: res => { 
                    if ( this.orcamento ) { 
                        if ( this.orcamento.marcacoes ) { 
                            this.orcamento.marcacoes.push(res);
                        } else { 
                            this.orcamento.marcacoes = [res];
                        }

                        this.$forceUpdate();
                    }
                }
            });
        },

        converter_selecao_medico(medico) { 

            $('.modal').modal('hide');

            let proc = this.proc_sel_medico ? this.proc_sel_medico : ( this.procedimentos.find(proc => !proc.medico) ); 
            
            if ( proc ) { 
                this.procedimentos.forEach(item => { 
                    if ( item.procedimento.id_especialidade == proc.procedimento.id_especialidade
                        && !item.medico ) { 

                        item.medico = medico;

                    }
                });

            }

            this.converter ();

        },

        converter(start = false) { 
            if ( start ) { 
                $('[data-toggle="tooltip"]').tooltip("dispose");
                $('.modal').modal('hide');
            }

            const info = this.get_info_orcamento();

            if ( !info.id_unidade_operacao && !this.orc_convert_unidades ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Para converter em atendimento, é necessário ter selecionado a unidade desejada.",
                    life: 5000
                });
                return;
            }

            if ( !info.id_plano ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Para converter em atendimento, é necessário ter selecionado a operadora/plano desejado.",
                    life: 5000
                });
                return;
            }

            /*
            let proc = info.js_procedimentos.find(proced => proced && !proced.medico)

            if ( proc ) { 

                this.lista_medicos = null;

                $('#selecMedicoModal').modal('show');

                this.$util.load(this, { 
                    service: 'marcacoes',
                    func: 'lista_alterar_profissional',
                    parms: { 
                        orcamento: true, 
                        id_procedimento: proc.procedimento.id_procedimento, 
                        id_operadora: info.plano.id_operadora, 
                    },
                    loadTo: res => { 
                        this.lista_medicos = res.filter(item => item && item.medico_unidade && item.medico_unidade.medico);
                    }
                });
                
                return;

            }
            */

            if ( start || ( !info.id_orcamento && !info.id_paciente && this.fluxo != 1 ) ) { 
                this.cadastro_temporario.st_nome = info.st_nome;

                if ( this.orc_convert_unidades ) { 
                    let uo = this.$util.unidade_operacao();
                    this.selecao_id_unidade_operacao = uo ? uo.id_unidade_operacao : ( info.id_unidade_operacao ? info.id_unidade_operacao : "" );
                } 
            
                this.acao = 'G';

                if ( this.is_lab ) { 
                    this.selec_proc = false;
                }

                $('#compartilharOrcamentoModal').modal('show');          

                return;
            }

            if ( this.selecao_id_unidade_operacao ) { 
                info.id_unidade_operacao = this.selecao_id_unidade_operacao;
            }

            this.nome_paciente = this.fluxo == 1 ? this.cadastro_temporario.st_nome : info.st_nome;

            //

            let lista;

            if ( this.fluxo && this.acao == 'G' ) { 

                if ( this.selec_proc && this.orcamento && this.orcamento.vacinas && this.orcamento.vacinas.length ) { 
                    if ( !this.orcamento.vacinas.find (item => item.selecionado) ) { 
                        this.$toast.add({
                            severity: "error",
                            summary: "Converter",
                            detail: "Selecione os itens desejados.",
                            life: 5000
                        });

                        return;
                    }

                    lista = this.orcamento.vacinas;
                }

            }

            //

            console.log('lista', lista);
            console.log('info', info.js_procedimentos);

            let proc = info.js_procedimentos.find(proced => proced && !proced.medico 
                && ( !lista || lista.find(il => il.selecionado && il.id_procedimento == proced.procedimento.id_procedimento) ) );

            console.log('proc', proc);

            if ( proc ) { 

                this.lista_medicos = null;
                this.proc_sel_medico = proc; 

                this.$util.load(this, { 
                    service: 'marcacoes',
                    func: 'lista_alterar_profissional',
                    parms: { 
                        orcamento: true, 
                        id_procedimento: proc.procedimento.id_procedimento, 
                        id_operadora: info.plano.id_operadora, 
                        is_lab: this.is_lab,
                        id_unidade_operacao: info.id_unidade_operacao,
                    },
                    loadTo: res => { 
                        this.lista_medicos = res.filter(item => item && item.medico_unidade && item.medico_unidade.medico);

                        if ( this.lista_medicos && this.lista_medicos.length == 1 && _.get(this.lista_medicos, '0.medico_unidade.medico') ) { 
                            this.converter_selecao_medico(this.lista_medicos[0].medico_unidade.medico);
                            return;
                        }
                        
                        $('#selecMedicoModal').modal('show');
                    }
                });
                
                return;

            }

            //

            let info_convert = _.cloneDeep(info);

            if ( lista && lista.length ) { 
                info_convert.js_procedimentos = info_convert.js_procedimentos.filter(item => lista.find(il => il.selecionado && il.id_procedimento == item.procedimento.id_procedimento));
                lista = null; 
            }

            //
                    
            this.$nextTick(() => {
                this.$util.atualizar (this, {
                    service: 'orcamentos',
                    func: 'converter',
                    dados: { 
                        ...info_convert,
                        agenda_procs: lista,
                    },
                    toast: true, 
                    callback: res => { 
                        if ( !this.orcamento ) { 
                            this.orcamento = info;
                        }

                        if ( this.orcamento && this.orcamento.id_orcamento == this.id_orcamento ) { 
                            if ( !this.orcamento.marcacoes ) { 
                                this.orcamento.marcacoes = [];
                            }

                            if ( res.retorno ) { 
                                this.orcamento.marcacoes.push(res.retorno);
                            }
                        }

                        $('.modal').modal('hide');
                    }
                });
            });
        },

        total_comparacao (id_plano) { 
            return this.procedimentos.reduce((total, carry) => { 
                if ( !carry.comparacao ) 
                    return total;

                const compara = carry.comparacao.find(comp => comp.plano.id_plano == id_plano);

                if ( !compara )
                    return total;

                return total + ( compara.valor.valor * carry.in_quantidade)
                    + carry.atendimento_procedimento_consumos.reduce((totalc, carryc) => { 
                        const consumo_comp = compara.consumos.find(consumo => 
                            ( consumo.id_material && consumo.id_material == carryc.id_material ) 
                            || ( consumo.id_medicamento && consumo.id_medicamento == carryc.id_medicamento ) 
                            || ( consumo.id_taxa && consumo.id_taxa == carryc.id_taxa ) 
                        );

                        if ( !consumo_comp ) 
                            return totalc;

                        return totalc + (consumo_comp.dc_valor_unitario * carryc.in_quantidade)
                    }, 0);

            }, 0);
        },

        abrir_paciente () { 
            if ( this.paciente )
                this.$root.perfil(this.paciente);
        },

        selecionar_orcamento (orc) { 
            this.validate = false;

            $('.modal').modal('hide');

            this.procedimentos = [];

            this.abrindo_orcamento = true;

            this.$nextTick(() => { 

                this.$emit(
                    'selecionado', 
                    { 
                        plano: orc.plano, 
                        unidade_operacao: orc.unidade_operacao, 
                        procedimentos: orc.js_procedimentos 
                            ? orc.js_procedimentos.map(item => { 
                                    item.selected = true;
                                    return item;
                                })
                            : null,
                    }
                );

                this.nome_paciente = orc.paciente 
                    ? orc.paciente.st_nome 
                    : ( orc.st_nome ? orc.st_nome : orc.st_titulo );
                this.titulo = orc.st_titulo;
                this.dados_share.nome = this.nome_paciente;
                this.dados_share.email = orc.st_email;
                this.dados_share.celular = orc.st_celular;
                this.dados_share.cpf = orc.st_cpf;
                this.observacoes = orc.st_observacoes;
                this.id_orcamento = orc.id_orcamento;
                this.procedimentos = orc.js_procedimentos;
                this.desconto_tipo = orc.desconto_tipo;
                this.desconto = orc.dc_desconto ? orc.dc_desconto : 0;
                this.tipo_desconto = orc.ch_tipo_desconto == 'V' ? 'V' : 'P';
                this.paciente = orc.paciente;
                this.fluxo = orc.paciente ? 2 : 1;
                this.id_pagamento_atendimento = orc.id_pagamento_atendimento;
                this.orcamento = orc;
                this.js_classes = orc.js_classes ? orc.js_classes : [];
                this.info = { 
                    medico_solicitante: orc.solicitante
                };
                this.desconto_tipo = orc.desconto_tipo; 

                if ( orc.js_outros_campos && orc.js_outros_campos.qt_pac > 0 ) { 
                    this.dados.qt_pac = orc.js_outros_campos.qt_pac;
                }

                if ( orc.js_outros_campos && orc.js_outros_campos.id_regiao_cd > 0 && this.regioes ) { 
                    let regiao = this.regioes.find(reg => reg.id_regiao_cd == orc.js_outros_campos.id_regiao_cd);

                    if ( regiao ) { 
                        this.dados.regiao_cd = regiao;
                    }
                }

                this.$nextTick(() => { 
                    this.abrindo_orcamento = false;

                    if ( this.$refs.instruc_orc ) { 
                        this.$refs.instruc_orc.reset();
                        this.$refs.instruc_orc.buscar_procedimento(this.dados);
                    }
                });

            });
        },

        buscar_orcamento() { 
            this.busca_orc = true;

            this.$nextTick(() => { 
                $('#buscarOrcamentoModal').modal('show');
            });
        },

        salvar_orcamento_paciente() { 
            if ( this.id_orcamento && this.orcamento && this.orcamento.msg_editar ) { // this.id_pagamento_atendimento 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: this.orcamento.msg_editar,
                    life: 3000
                });
                return;
            }

            if ( !this.id_orcamento ) { 
                this.fluxo = null;

                if ( this.paciente && this.paciente.id_pessoa ) { 
                    this.fluxo = 2;
                }
            }

            this.acao = 'S';
            $('#compartilharOrcamentoModal').modal('show');
        },
        
        salvar_orcamento (nao_informado = false, ciente = false) { 
            if ( this.busca_orc ) { 
                this.$refs.consorc.reset();
            }

            if ( !this.dados.plano ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Plano não selecionado.",
                    life: 5000
                });
                return;
            }

            if ( nao_informado ) { 
                this.dados_share.nome = 'NAO INFORMADO';    
            } 
            
            this.nome_paciente = this.dados_share.nome;
            
            let outros_campos;

            if ( this.dados.regiao_cd && this.dados.regiao_cd.id_regiao_cd ) { 
                outros_campos = { 
                    id_regiao_cd: this.dados.regiao_cd ? this.dados.regiao_cd.id_regiao_cd : null,
                    qt_pac: this.dados.qt_pac, 
                };
            }

            this.$util.atualizar (this, {
                service: 'orcamentos',
                func: 'store',
                dados: { 
                    st_titulo: this.titulo ? this.titulo : this.dados_share.nome,  
                    id_paciente: this.paciente ? this.paciente.id_pessoa : null,  
                    id_orcamento: this.id_orcamento, 
                    id_plano: this.dados.plano.id_plano,
                    id_unidade_operacao: this.dados.unidade_operacao ? this.dados.unidade_operacao.id_unidade_operacao : null,
                    js_procedimentos: this.procedimentos, 
                    st_nome: this.dados_share.nome,
                    st_email: this.dados_share.email,
                    st_celular: this.dados_share.celular,
                    st_cpf: this.dados_share.cpf,
                    st_observacoes: this.observacoes, 
                    dc_desconto: this.desconto,
                    ch_tipo_desconto: this.tipo_desconto, 
                    origem_type: ( this.paciente && this.paciente.origem ) ? this.paciente.origem.type : null, 
                    origem_id: ( this.paciente && this.paciente.origem ) ? this.paciente.origem.id : null, 
                    solicitante: this.info ? this.info.medico_solicitante : null,
                    js_classes: this.js_classes, 
                    js_outros_campos: outros_campos, 
                    id_desconto_tipo: this.desconto_tipo ? this.desconto_tipo.id_desconto_tipo : null,
                    ciente: ciente,
                },
                toast: true, 
                callback: res => { 
                    this.id_orcamento = res.id_orcamento;
                    this.orcamento = res;
                    $('.modal').modal('hide');
                },
                callback_error: res => { 
                    if ( res && res.status >= 400 && res.data && res.data.instrucoes && res.data.instrucoes.length ) { 
                        this.$refs.ciente.abrir(res.data.instrucoes);
                    } 
                }
            });
        },

        editar_consumo(idx) {
            this.linha_incluir_consumo = ( this.linha_incluir_consumo === idx ? null : idx ); 
        },

        incluirComponentePrimeiro(componente) { 
            this.novoComponente = componente;
            this.incluirComponente(this.procedimentos[0]);
        },

        incluirComponente (proc) { 
            if ( !this.novoComponente )
                return;

            let novo = _.cloneDeep(this.novoComponente);
            this.novoComponente = "";

            this.$store.commit('loading', true);

            this.$util.loadItem(this, { 
                service: 'consumo', 
                func: 'valor',
                parms: { 
                    id_plano: this.dados.plano.id_plano,
                    id_material: novo.id_material,
                    id_taxa: novo.id_taxa,
                    id_medicamento: novo.id_medicamento,
                    id_unidade_operacao: this.dados.unidade_operacao ? this.dados.unidade_operacao.id_unidade_operacao : null,
                }
            })
            .then(valor => { 
                if ( valor ) { 
                    proc.atendimento_procedimento_consumos.push({ 
                        id_atendimento_procedimento: proc.id_atendimento_procedimento, 
                        id_material: novo.id_material,
                        id_taxa: novo.id_taxa,
                        id_medicamento: novo.id_medicamento,
                        in_quantidade: novo.qtde ? novo.qtde : ( proc.in_quantidade ? proc.in_quantidade : 1 ),
                        dc_valor_unitario: valor.valor,
                        id_propria: valor.id_propria,
                        id_item_tabela: valor.id_item_tabela,
                        id_simpro: valor.id_simpro,
                        id_brasindice: valor.id_brasindice,
                        search: novo.search, 
                        excluido: false, 
                        id_plano: this.novoPlanoCobranca ? this.novoPlanoCobranca.id_plano : null,  
                        plano: this.novoPlanoCobranca ? this.novoPlanoCobranca : null, 
                    });
                } else { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Item sem valor cadastrado para essa operadora.",
                        life: 3000
                    });
                }
            })
            .finally(() => { 
                this.$store.commit('loading', false);

                this.$nextTick(() => { 
                    this.novoComponente = null;
                });
            });

        },

        traduzir_tempo(num, tempo) { 
            switch (tempo) {
                case 'days': return num > 1 ? 'dias úteis' : 'dia util';
                case 'hours': return num > 1 ? 'horas' : 'hora';
            }

            return tempo;
        },

        remover_comparacao (idx) { 
            this.comparar_com.splice(idx, 1);

            this.$util.setCookie('orcamento-fixar-planos', JSON.stringify(this.comparar_com), 365);
        },

        fixar_plano () { 
            if ( !this.comparar_com )
                this.comparar_com = [];

            if ( this.comparar_com.find(item => item.id_plano = this.dados.plano.id_plano) ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Operadora/Plano já fixado.",
                    life: 3000
                });
                
                return;
            }

            this.comparar_com.push({ 
                id_plano: this.dados.plano.id_plano,
                search: this.dados.plano.search 
            });

            this.$forceUpdate();

            this.$util.setCookie('orcamento-fixar-planos', JSON.stringify(this.comparar_com), 365);
        },

        copiar_clipboard () { 
            let text = this.get_texto_orcamento(true);

            if (!navigator.clipboard) {
                var textArea = document.createElement("textarea");
                textArea.value = text;
                textArea.style.position="fixed";  //avoid scrolling to bottom
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    console.log('Fallback: Copying text command was ' + msg);
                } catch (err) {
                    console.error('Fallback: Oops, unable to copy', err);
                }

                document.body.removeChild(textArea);
            } else { 
                navigator.clipboard.writeText(text).then(function() {
                    console.log('Async: Copying to clipboard was successful!');
                }, function(err) {
                    console.error('Async: Could not copy text: ', err);
                });
            }

            this.$toast.add({
                severity: "success",
                summary: "Atenção",
                detail: "Copiado para a área de transferência.",
                life: 3000
            });
        },

        enviar_por_email() { 

             if (!this.dados_share.email ) {
                return "javascript:alert('Email não disponível')";
            }

            this.$util.atualizar(this, { 
                service: 'mensagens',
                func: 'enviar',
                dados: { 
                    texto: this.get_texto_orcamento(true),
                    assunto: 'Orçamento',
                    por: 'M',
                    destino: this.dados_share.email, 
                },
                callback: () => { 
                    this.$toast.add({
                        severity: "success",
                        summary: "Atenção",
                        detail: "Orçamento enviado por e-mail.",
                        life: 3000
                    });
                } 
            });

        },

        enviar_pelo_telegram() { 

            if (!this.dados_share.telegram) {
                return "javascript:alert('Telegram não disponível')";
            }

            this.$util.atualizar(this, { 
                service: 'mensagens',
                func: 'enviar',
                dados: { 
                    texto: this.get_texto_orcamento(true),
                    assunto: 'Orçamento',
                    por: 'T',
                    destino: this.dados_share.telegram, 
                },
                callback: () => { 
                    this.$toast.add({
                        severity: "success",
                        summary: "Atenção",
                        detail: "Orçamento enviado pelo Telegram.",
                        life: 3000
                    });
                } 
            });

        },

        enviar_pelo_whatsapp() { 

            if (!this.dados_share.celular) {
                return "javascript:alert('Celular não disponível')";
            }

            if (this.$store.state.user.wa_back) {
                this.$util.loadItem(this, { 
                        service: 'pep',
                        func: 'enviar_para_paciente_whatsapp',
                        parms: {
                            mensagem: this.get_texto_orcamento(),
                            nome: this.dados_share.nome,
                            numero: this.dados_share.celular
                        }
                })
                .then(res => { 

                $('#compartilharOrcamentoModal').modal('hide');

                if(res && res.status_code == 200) {
                    this.$toast.add({
                            severity: "success",
                            summary: "Atenção",
                            detail: "Mensagem enviada com sucesso",
                            life: 3000
                        });
                }

            })} else {

                let celular = "55" + this.dados_share.celular;
                let msg = this.get_texto_orcamento();

                window.open("https://wa.me/" + celular + "?text=" + encodeURIComponent(msg), '_blank')

            }

            


        },

        get_texto_orcamento(newline = false) { 
            let nl = "\n"; // newline ? "\n" : "%0D%0A";
            let texto = 'Prezado(a) *' + this.dados_share.nome + '*, ' + nl; 
            texto = texto + 'Segue abaixo orçamento solicitado em ' + this.$util.getFormatDate(this.$util.hoje()) + nl + nl;

            if ( this.id_orcamento ) { 
                texto = texto + 'Orçamento: *#' + this.id_orcamento + '*' + nl;
            }
            
            if ( this.titulo && this.titulo != this.dados_share.nome ) { 
                texto = texto + this.titulo + nl;
            }

            texto = texto + ( ( this.dados && this.dados.plano ) ? this.dados.plano.search : 'Particular' ) + nl;

            let tem_despesas = false;

            if ( !this.exibir_apenas_total ) { 

                texto = texto + nl; 

                this.procedimentos.forEach(item => { 
                    if ( item.procedimento.st_codigo_cbhpm ) { 
                        texto = texto + '- *' + item.procedimento.st_codigo_cbhpm + '* - ';
                    }
                    
                    texto = texto + item.procedimento.st_procedimento;
                    
                    if ( this.nao_exibir_valor_do_item ) { 

                        if ( item.in_quantidade > 1 ) { 
                            texto = texto + ' => x' + item.in_quantidade;
                        }

                    } else { 
                    
                        texto = texto + ' => ';

                        if ( item.atendimento_pacote ) { 
                            texto = texto + item.atendimento_pacote.search;
                            texto = texto + ' / R$ ' + this.$util.formatMoeda(item.atendimento_pacote.dc_valor_pacote);
                        } else { 
                            if ( item.in_quantidade > 1 ) { 
                                texto = texto + item.in_quantidade + ' x R$ ' + this.$util.formatMoeda(item.dc_valor_procedimento) + ' = ';
                            }

                            texto = texto + ' R$ ' + this.$util.formatMoeda(item.dc_valor_procedimento * item.in_quantidade);
                        }

                    }

                    texto = texto + nl;
                    
                    if ( item.atendimento_procedimento_consumos.length ) { 

                        tem_despesas = true;

                        //if ( this.exibir_mat_med_tx ) { 

                        texto = texto + 'MAT/MED/TAXAS => R$ ' + 
                            this.$util.formatMoeda(
                                item.atendimento_procedimento_consumos.reduce((total, carry) => { 
                                    return total + (carry.in_quantidade * carry.dc_valor_unitario)
                                }, 0)
                            ) + nl; 

                    }
                });

            }

            texto = texto + nl; 

            if ( this.procedimentos.length > 1 || tem_despesas )
                texto = texto + '*Valor Total => R$ ' + this.$util.formatMoeda(this.total_orcado) + '*' + nl;

            if ( this.valor_desconto > 0 ) { 
                texto = texto + '*Desconto => R$ ' + this.$util.formatMoeda(this.valor_desconto) + '*' + nl;
                texto = texto + '*Valor Final => R$ ' + this.$util.formatMoeda(this.total_orcado - this.valor_desconto) + '*' + nl;
            }

            texto = texto + nl;

            const instrucoes = this.$refs.instruc_orc.get_texto(newline);
            
            if ( this.observacoes ) { 
                texto = texto + '```---------------------------```' + nl + nl;
                texto = texto + this.observacoes + nl + nl;
            }

            if ( this.exibir_inst && instrucoes ) { 
                texto = texto + '```---------------------------```' + nl + nl;
                texto = texto + instrucoes + nl ;
            }

            return texto;
        },

        reiniciar_salvamento () { 
            if ( this.fluxo == 2 && this.paciente ) { 
                this.dados_share.nome = "";
                this.dados_share.email =  "";
                this.dados_share.celular = "";
                this.dados_share.telegram = "";
                this.dados_share.cpf = "";
            }

            this.fluxo = null;
            this.paciente = null;
        },

        selecionarPaciente() { 
            if ( !this.paciente ) { 
                this.dados_share.nome = "";
                this.dados_share.email = "";
                this.dados_share.celular = "";
                this.dados_share.telegram = "";    
                this.dados_share.cpf = "";

                return;
            }

            this.dados_share.nome = this.paciente.st_nome_social ? this.paciente.st_nome_social : this.paciente.st_nome;
            this.dados_share.email = this.paciente.cadastro.st_email;
            this.dados_share.celular = this.paciente.cadastro.telefones.celular;
            this.dados_share.telegram = this.paciente.cadastro.st_telegram_chat_id;
            this.dados_share.cpf = this.paciente.cadastro.st_cpf;
        },

        compartilhar() { 
            if ( !this.id_orcamento ) { 
                this.fluxo = null;

                if ( this.nao_imprimir_orcamento_sem_salvar ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Orçamento não salvo.",
                        life: 3000
                    });
                    return;
                }
            }

            this.acao = 'C';
            $('#compartilharOrcamentoModal').modal('show');
        },

        startFluxo(fluxo) { 
            this.fluxo = fluxo;

            if ( fluxo == 2 && this.nome_paciente ) { 
                this.dados_share.nome = this.nome_paciente;
            }

            if ( fluxo == 1 && this.acao == 'A' ) { 
                this.agendar();
            } else if ( fluxo == 1 && this.acao == 'G' ) { 
                // this.converter();
            }
        },

        alterar_qtde_consumo (item, plus) { 

            if ( item.in_quantidade == 1 && !plus )
                return;

            let base = item.in_quantidade;

            item.in_quantidade = base + ( 1 * ( plus ? 1 : -1 ) );

        },

        alterar_qtde (proc, plus) { 

            if ( proc.in_quantidade == 1 && !plus )
                return;

            let atual = proc.in_quantidade;

            proc.in_quantidade = proc.in_quantidade + ( 1 * ( plus ? 1 : -1 ) );

            proc.atendimento_procedimento_consumos.forEach(item => { 

                if ( !item.fl_nao_repetir ) { 
                    if ( !atual ) { 
                        item.in_quantidade = 1;    
                    } else { 
                        item.in_quantidade = Math.round( ( item.in_quantidade / atual ) * proc.in_quantidade );
                    }
                }
            });

            this.$forceUpdate();

        },

        remover (idx) { 
            this.removendo = true;

            this.$nextTick(() => { 
                this.procedimentos.splice(idx, 1);
                this.removendo = false;
            });
        },

        remover_consumo (proc, idx) { 
            this.removendo = true;

            this.$nextTick(() => { 
                proc.atendimento_procedimento_consumos.splice(idx, 1);
                this.removendo = false;
            });
        },

        recalcular_items (lista, nivel = 0) { 

            let item = lista.shift();

            if ( !item || nivel > 1000 ) { 
                return;
            }

            this.$util.loadItem(this, { 
                service: 'procedimentos',
                func: 'valor',
                parms: { 
                    id_procedimento: item.procedimento.id_procedimento,
                    id_plano: this.dados.plano.id_plano,
                    id_unidade_operacao: this.dados.unidade_operacao ? this.dados.unidade_operacao.id_unidade_operacao : null, 
                    id_medico: item.medico ? item.medico.id_pessoa : null, 
                    lista: [], // this.lista... 
                    incluir: true, 
                }
            })
            .then(res => { 
                
                if ( res ) { 

                    if ( !res.valor ) { 

                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: "Item sem valor cadastrado.",
                            life: 3000
                        });

                    } else { 

                        item.id_item_tabela = res.valor.id_item_tabela;
                        item.item_tabela = _.pick(res.valor.item_tabela, ['id_item_tabela', 'st_nome', 'st_codigo', 'search']);

                        if ( _.get(item, 'procedimento.fl_block_valor') ) { 
                            item.dc_valor_procedimento = 0;     
                        } else { 
                            item.dc_valor_procedimento = Math.round(res.valor.valor * 100) / 100;
                        }

                    }

                }
            }).finally(() => { 

                if ( lista.length ) { 
                    this.recalcular_items(lista, nivel + 1);
                } else { 
                    this.$store.commit('loading', false);
                    this.imprimindo = false;
                }

            });

        },

        recalcular() { 

            let last = this.procedimentos.filter(item => !item.excluido);

            if ( !last.length || this.abrindo_orcamento )
                return;

            this.imprimindo = true;

            last = last.slice(-1)[0];

            this.$store.commit('loading', true);

            this.recalcular_items(this.procedimentos.filter(item => !item.excluido));

            /*
            this.procedimentos.filter(item => !item.excluido)
                .forEach(item => { 

                this.$util.loadItem(this, { 
                    service: 'procedimentos',
                    func: 'valor',
                    parms: { 
                        id_procedimento: item.procedimento.id_procedimento,
                        id_plano: this.dados.plano.id_plano,
                        id_unidade_operacao: this.dados.unidade_operacao ? this.dados.unidade_operacao.id_unidade_operacao : null, 
                        id_medico: item.medico ? item.medico.id_pessoa : null, 
                        lista: [], // this.lista... 
                        incluir: true, 
                    }
                })
                .then(res => { 
                    
                    if ( res ) { 

                        if ( !res.valor ) { 

                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: "Item sem valor cadastrado.",
                                life: 3000
                            });

                        } else { 

                            item.id_item_tabela = res.valor.id_item_tabela;
                            item.item_tabela = res.valor.item_tabela;
                            item.dc_valor_procedimento = res.valor.valor;

                        }

                    }
                }).finally(() => { 
                    if ( last.procedimento.id_procedimento == item.procedimento.id_procedimento )
                        this.$store.commit('loading', false);

                    this.imprimindo = false;
                });

            });
            */
        },

        imprimir() {

            this.cabecalho = null;

            this.$util.setCookie('orc-exibir-inst', this.exibir_inst ? 'S' : 'N');
            this.$util.setCookie('orc-matmed', this.exibir_mat_med_tx ? 'S' : 'N');
            this.$util.setCookie('orc-block-vi', this.nao_exibir_valor_do_item ? 'S' : 'N' ); 

            if ( this.id_orcamento ) { 
                this.salvar_orcamento(false, true); 
            } else if ( this.nao_imprimir_orcamento_sem_salvar ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Orçamento não salvo.",
                    life: 3000
                });
                return;
            }

            let func_print = () => { 

                this.$util.load(this, { 
                    service: 'orcamentos',
                    func: 'get_cabecalho',
                    parms: { 
                        id_orcamento: this.id_orcamento, 
                        id_plano: this.dados.plano.id_plano,
                        id_unidade_operacao: this.dados.unidade_operacao ? this.dados.unidade_operacao.id_unidade_operacao : null,
                    },
                    loadTo: res => { 
                        this.cabecalho = res.cabecalho;
                        this.imprimindo = true;

                        this.$refs.print.imprimir_direto();
                    }
                });

            }

            //

            if ( this.$refs.instruc_orc && this.exibir_inst ) { 
                this.$refs.instruc_orc.reset();
                this.$refs.instruc_orc.buscar_procedimento(this.dados, func_print);
            } else { 
                func_print();
            }
            
            //

            /*
            this.$util.load(this, { 
                service: 'orcamentos',
                func: 'get_cabecalho',
                parms: { 
                    id_orcamento: this.id_orcamento, 
                    id_plano: this.dados.plano.id_plano,
                    id_unidade_operacao: this.dados.unidade_operacao ? this.dados.unidade_operacao.id_unidade_operacao : null,
                },
                loadTo: res => { 
                    this.cabecalho = res.cabecalho;
                    this.imprimindo = true;

                    this.$refs.print.imprimir_direto();
                }
            });
            */

            return false;
            
        },

        pos_imprimir() { 
            this.imprimindo = false;
        },

        reset () { 
            this.validate = false;
            this.nome_paciente = "";
            this.desconto = 0;
            this.tipo_desconto = 'P';
            this.observacoes = this.obs_padrao ? this.obs_padrao : ''; 
            this.titulo = '';
            this.parcelamento = '';
            this.id_orcamento = null; 
            this.procedimentos = [];
            this.id_pagamento_atendimento = null;
            this.paciente = null;
            this.info = { 
                medico_solicitante: null, 
            };
            this.js_classes = [];
        },

        incluir_procedimento_lista(lista, medico, index, callback = null) { 
            let proximo = lista.shift();

            this.incluirProcedimento(proximo, medico, index, () => { 
                if ( lista.length ) { 
                    this.incluir_procedimento_lista(lista, medico, index, callback);
                } else { 
                    if ( callback )
                        callback();
                }
            });
        },

        incluirProcedimento (novo, medico = null, index = null, callback = null) { 

            if ( this.id_orcamento && this.orcamento && this.orcamento.msg_editar ) { // this.id_pagamento_atendimento 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: this.orcamento.msg_editar,
                    life: 3000
                });
                return;
            }

            if ( novo ) { 

                if ( this.procedimentos.find(item => item.procedimento && item.procedimento.id_procedimento == novo.id_procedimento) ) { 

                    if ( novo.id_especialidade == 2 ) { 
                        if ( !confirm("Procedimento '" + novo.search + "' já lançado. Confirma repetir o lançamento?") ) { 
                            return;
                        }
                    } else { 
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: "Procedimento '" + novo.search + "' já lançado.",
                            life: 3000
                        });
                        return;
                    }
                    
                }

                if ( novo.id_pacote && !this.titulo ) { 
                    this.titulo = novo.search;
                }

                let loading = this.$store.state.loading ? true : false; 

                this.$store.commit('loading', true);

                let tipo_consulta = this.dados.tipo_consulta;

                this.$util.loadItem(this, { 
                    service: 'procedimentos',
                    func: 'valor',
                    parms: { 
                        id_procedimento_pai: novo.id_procedimento_pai, 
                        id_procedimento: novo.id_procedimento,
                        id_plano: this.dados.plano.id_plano,
                        id_unidade_operacao: this.dados.unidade_operacao ? this.dados.unidade_operacao.id_unidade_operacao : null, 
                        id_medico: medico ? medico.id_pessoa : null, 
                        lista: this.procedimentos, 
                        index: -1, 
                        incluir: true, 
                        comparar_com: this.comparar_com.map(item => item.id_plano),
                        orcamento: true, 
                        id_regiao_cd: ( !loading && !this.procedimentos.length && this.dados.regiao_cd ) ? this.dados.regiao_cd.id_regiao_cd : null,
                        tipo_consulta: tipo_consulta,
                    }
                })
                .then(res => { 
                    
                    if ( res ) { 

                        if ( novo.id_pacote || res.lista ) { 

                            res.lista.forEach(element => {

                                if ( element.valor ) { 

                                    let cons = this.tratar_repeticao(element.consumos);

                                    console.log(_.get(element, 'procedimento.search', 'teste'), element);

                                    this.procedimentos.push({ 
                                        id_item_tabela: element.valor.id_item_tabela,
                                        item_tabela: _.pick(element.valor.item_tabela, ['id_item_tabela', 'st_nome', 'st_codigo', 'search']),
                                        procedimento: _.omit(element.procedimento, ['unidade_procedimento', 'fl_pre_atendimento', 'fl_imprimir_separado', 'in_registo_importacao', 'fl_imprimir_separado', 'sinonimos', 'fl_pag_online', 'fl_simultaneo']),
                                        in_quantidade: element.in_quantidade ? element.in_quantidade : 1,
                                        dc_valor_procedimento: Math.round(element.valor.valor * 100) / 100,
                                        excluido: false, 
                                        incluir_consumo: false, 
                                        atendimento_procedimento_consumos: cons,
                                        atendimento_procedimento_equipes: [],
                                        id_reducao: element.valor.id_reducao,
                                        medico: medico, 
                                        atendimento_procedimento: null, 
                                    });

                                }
                                
                            });
                            
                        } else { 

                            if ( !res.valor ) { 

                                this.$toast.add({
                                    severity: "error",
                                    summary: "Atenção",
                                    detail: "Item sem valor cadastrado. \n" + ( res.proc ? res.proc.search : '' ),
                                    life: 3000
                                });

                            } else { 

                                if ( res.sem_preco === true ) { 
                                    this.$toast.add({
                                        severity: "error",
                                        summary: "Atenção",
                                        detail: "Procedimento sem preço para essa operadora. \n" + ( res.proc ? res.proc.search : '' ),
                                        life: 5000
                                    });
                                    return;
                                }

                                if ( novo.fl_block_valor ) { 
                                    res.valor.valor = 0;
                                    // res.consumos = [];
                                }

                                let block_lanc = false;

                                if ( res.restricao && res.restricao[0] && res.restricao[0].fl_nao_possui_cobertura ) { 

                                    block_lanc = res.restricao[0].fl_bloqueia_lancamento;

                                    this.$toast.add({
                                        severity: "error",
                                        summary: "Item sem cobertura",
                                        detail: ( res.proc ? res.proc.search : '' ) 
                                            + ( block_lanc ? '\n \n Lançamento bloqueado.' : '' ),
                                        life: 5000
                                    });

                                }

                                const qtc = ( novo && novo.in_qtde_default ) ? novo.in_qtde_default : 1;

                                if ( !block_lanc ) { 

                                    let cons = this.tratar_repeticao(res.consumos, index, qtc);

                                    if ( res.proc ) { 
                                        novo.procedimento_pacotes = res.proc.procedimento_pacotes;
                                    }

                                    if ( res.proc.in_prazo_entrega ) { 
                                        novo.in_prazo_entrega = res.proc.in_prazo_entrega;
                                    }

                                    if ( novo.dc_valor_default && res.valor ) { 
                                        res.valor.valor = novo.dc_valor_default;
                                        res.valor.original = novo.dc_valor_default;
                                    }

                                    this.procedimentos.push({ 
                                        id_item_tabela: res.valor.id_item_tabela,
                                        item_tabela: _.pick(res.valor.item_tabela, ['id_item_tabela', 'st_nome', 'st_codigo', 'search']),
                                        procedimento: _.omit(novo, ['unidade_procedimento', 'fl_pre_atendimento', 'fl_imprimir_separado', 'in_registo_importacao', 'fl_imprimir_separado', 'sinonimos', 'fl_pag_online', 'fl_simultaneo']),
                                        in_quantidade: qtc,
                                        dc_valor_procedimento: Math.round(res.valor.valor * 100) / 100,
                                        dc_valor_original: _.get(res, 'valor.original'),
                                        excluido: false, 
                                        fl_ativo: true, 
                                        incluir_consumo: false, 
                                        atendimento_procedimento_consumos: cons.filter(item => !item.id_procedimento_item),
                                        atendimento_procedimento_equipes: [],
                                        id_reducao: res.valor.id_reducao,
                                        comparacao: res.comparar, 
                                        medico: medico, 
                                        atendimento_procedimento: null, 
                                        fl_block_valor: novo.fl_block_valor,
                                        fl_block_laudo: novo.fl_block_laudo,
                                        ed: res.plano ? res.plano.valor_editavel : false, 
                                        tipo_consulta: tipo_consulta,
                                    });

                                    let procs = cons.filter(item => item.id_procedimento_item)
                                        .filter(item => { 
                                            const teste = this.procedimentos.filter(proc => proc.procedimento.id_procedimento == novo.id_procedimento).length;
                                            return item.id_procedimento_item != novo.id_procedimento || teste <= 1;
                                        });

                                    procs = procs.map(item => { 
                                        return { 
                                            id_procedimento_pai: item.id_procedimento_pai
                                                ? item.id_procedimento_pai
                                                : item.id_procedimento,
                                            id_procedimento: item.id_procedimento_item,
                                            st_procedimento: item.search,
                                            search: item.search, 
                                            in_qtde_default: item.in_quantidade ? item.in_quantidade : 1, 
                                            dc_valor_default: item.dc_valor_unitario ? item.dc_valor_unitario : null,
                                            fl_block_valor: ( item.fl_block_valor || novo.fl_block_valor ),
                                            fl_block_laudo: ( item.fl_block_laudo || novo.fl_block_laudo ),
                                            id_especialidade: item.id_especialidade, 
                                        };
                                    });

                                    procs = _.reverse(procs);

                                    procs.forEach(item => { 
                                        this.$parent.lista_adicao.unshift(item);
                                    })

                                    // this.incluir_procedimento_lista(procs, medico, null); 

                                    /*
                                    procs.forEach(item => { 

                                        console.log('comp', item.search);

                                        this.incluirProcedimento (
                                            { 
                                                id_procedimento_pai: item.id_procedimento_pai
                                                    ? item.id_procedimento_pai
                                                    : item.id_procedimento,
                                                id_procedimento: item.id_procedimento_item,
                                                st_procedimento: item.search,
                                                search: item.search, 
                                                in_qtde_default: item.in_quantidade ? item.in_quantidade : 1, 
                                                fl_block_valor: ( item.fl_block_valor || novo.fl_block_valor ),
                                                fl_block_laudo: ( item.fl_block_laudo || novo.fl_block_laudo ),
                                                id_especialidade: item.id_especialidade, 
                                            }, 
                                            medico,
                                        );
                                    });
                                    */

                                }

                            }

                        }
                
                    }
                }).finally(() => { 
                    this.$store.commit('loading', false);

                    this.$nextTick(() => {
                        novo = null;

                        if ( this.$refs.instruc_orc ) { 
                            this.$refs.instruc_orc.reset();
                            this.$refs.instruc_orc.buscar_plano(this.dados);
                            this.$refs.instruc_orc.buscar_procedimento(this.value);
                        }
                    });

                    if ( callback ) { 
                        callback();
                    }
                });

            }

        },

        tratar_repeticao (consumos, index = -1, qtc = 1) { 
            if ( !consumos ) { 
                return [];
            }

            let consumos_lancados = this.procedimentos.filter((item, idx) => index != idx 
                    && item.atendimento_procedimento_consumos
                )
                .flatMap(item => item.atendimento_procedimento_consumos);

            return consumos.filter (item => !item.fl_nao_repetir 
                || !consumos_lancados.find(cns => 
                        ( !cns.id_material || ( cns.id_material == item.id_material) )
                        && ( !cns.id_medicamento || ( cns.id_medicamento == item.id_medicamento) ) 
                        && ( !cns.id_taxa || ( cns.id_taxa == item.id_taxa ) ) 
                    ) 
                )
                .map(item => { 
                    if ( !item.fl_nao_repetir && qtc > 1 ) {
                        item.in_quantidade = item.in_quantidade * qtc; 
                    }
                    
                    return item;
                });
        }


    },

    mounted() { 

        this.$util.loadItem(this, {
            service: 'orcamentos',
            func: 'tags',
            parms: { 
                only_more: true 
            }
        })
        .then(res => {
            if ( res ) { 
                this.options_classes = res;
            }
        });

        if ( this.$store.state.contexto.orc_configs ) { 

            this.atender_proc_sem_agenda = this.$store.state.contexto.orc_config_atender_proc_sem_agenda || this.$store.state.contexto['atender-proc-sem-agenda'];
            this.nao_imprimir_orcamento_sem_salvar = this.$store.state.contexto.orc_config_nao_imprimir_orcamento_sem_salvar || this.$store.state.contexto['nao-imprimir-orcamento-sem-salvar'];
            this.sem_valor_sem_salvar = this.$store.state.contexto['orcamento-valor-apenas-quando-salvo'] ? true : false;
            this.desconto_tipo_ident = this.$store.state.contexto.orc_config_desc_tipo_ident;

        } else { 

            this.$util.loadItem(this, { 
                    service: 'configuracoes',
                    func: 'index',
                    parms: {
                        where: {
                            st_slug: 'orcamento-desconto-tipo-identificado',
                            fl_ativo: '1',
                        }
                    },
                    configs: [
                        'atender-proc-sem-agenda', 
                        'nao-imprimir-orcamento-sem-salvar', 
                        'orcamento-valor-apenas-quando-salvo', 
                        'orcamento-block-nao-informado', 
                    ]
                })
                .then(res => { 
                    if ( res.length && res[0].st_valor > 0 ) { 
                        this.desconto_tipo_ident = true;
                    }

                    this.$store.commit('setContexto', { 
                        orc_config_desc_tipo_ident: this.desconto_tipo_ident,
                        orc_configs: true, 
                    });

                    if ( this.$store.state.contexto['atender-proc-sem-agenda'] ) { 
                        this.atender_proc_sem_agenda = true;
                    }

                    if ( this.$store.state.contexto['nao-imprimir-orcamento-sem-salvar'] ) { 
                        this.nao_imprimir_orcamento_sem_salvar = true;
                    }
                    
                    if ( this.$store.state.contexto['orcamento-valor-apenas-quando-salvo'] ) { 
                        this.sem_valor_sem_salvar = true; 
                    }

                    if ( this.$store.state.contexto['orcamento-block-nao-informado'] ) { 
                        this.block_nao_informado = true; 
                    }
                });

            /*
            this.$util.loadItem(this, { 
                    service: 'configuracoes',
                    func: 'index',
                    parms: {
                        where: {
                            st_slug: 'atender-proc-sem-agenda',
                            fl_ativo: '1',
                        }
                    }
                })
                .then(res => { 
                    if ( res.length && res[0].st_valor > 0 ) { 
                        this.atender_proc_sem_agenda = true;
                    }

                    this.$store.commit('setContexto', { 
                        orc_config_atender_proc_sem_agenda: this.atender_proc_sem_agenda,
                        orc_configs: true, 
                    });
                });
            
            this.$util.loadItem(this, { 
                    service: 'configuracoes',
                    func: 'index',
                    parms: {
                        where: {
                            st_slug: 'nao-imprimir-orcamento-sem-salvar',
                            fl_ativo: '1',
                        }
                    }
                })
                .then(res => { 
                    if ( res.length && res[0].st_valor > 0 ) { 
                        this.nao_imprimir_orcamento_sem_salvar = true;
                    }

                    this.$store.commit('setContexto', { 
                        orc_config_nao_imprimir_orcamento_sem_salvar: this.nao_imprimir_orcamento_sem_salvar,
                        orc_configs: true, 
                    });
                });
            */

        }

        const fixos = this.$util.getCookie('orcamento-fixar-planos');
        const lista = fixos ? JSON.parse(fixos) : null;

        this.comparar_com = lista ? lista : [];

        this.$util.loadItem(this, { 
            service: 'configuracoes',
            func: 'index',
            parms: {
                where: {
                    st_slug: 'orcamento-obs-padrao',
                }
            }
        })
        .then(res => { 
            if ( res.length && res[0].st_valor ) { 
                this.obs_padrao = res[0].st_valor;
                this.observacoes = this.obs_padrao;
            }
        });
    }
}
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}

.modal-dialog2 {
  width: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}
</style>